import React, { useState, useRef, useEffect } from 'react';
import axios from "axios";     
import { MultiSelect } from "react-multi-select-component"; 
import { Modal } from 'react-bootstrap';
import { getCustomerPortalApi } from '../../../config';
import api from '../../../services/api';
import { Link, useNavigate } from 'react-router-dom';
import { getSettings } from '../../../models/settingsModel';

const NewSupplier = () => {
   
        const navigate = useNavigate();
        const [newRegisterFeedback, setNewRegisterFeedback] = useState("");  
        const [showDebugModal, setShowDebugModal] = useState(false);
        const [Silulumanzi_Employee, setSilulumanzi_Employee] = useState("No");
        const [Silulumanzi_Recent_Employee, setSilulumanzi_Recent_Employee] = useState("No");
        const [Silulumanzi_Employee_Relative, setSilulumanzi_Employee_Relative] = useState("No");
        const [Silulumanzi_Official_Relationship, setSilulumanzi_Official_Relationship] = useState("No");
        const [Voluntary_Disclosure, setVoluntary_Disclosure] = useState("No"); 
        const [Hazardous_Substances, setHazardous_Substances] = useState("No");
        const [registerFeedback, setRegisterFeedback] = useState("");  
        const [businessType, setBusinessType] = useState([]);
        const [attachments, setAttachments] = useState({});
        const [submitStatus, setSubmitStatus] = useState(null);
        const [reviewData, setReviewData] = useState({});
        const [settings, setSettings] = useState(null);
        const [services, setServices] = useState([]);
        const [registerOTP, setRegisterOTP] = useState(false);  
        const [reference, setReference] = useState(0);  
        const [progress, setProgress] = useState(0); 
        const [sameAsPhysical, setSameAsPhysical] = useState(false);
        const [formDataObject, setFormDataObject] = useState({}); 
        const [formFiles, setFormFiles] = useState({});  
        const [selected, setSelected] = useState([]);
        const [step, setStep] = useState(1); 
        const formRef = useRef();
        
        // OTP and account setup state
        const [otpSent, setOtpSent] = useState(false);
        const [otpCode, setOtpCode] = useState('');
        const [otpVerified, setOtpVerified] = useState(false);
        const [password, setPassword] = useState('');
        const [confirmPassword, setConfirmPassword] = useState('');
        const [passwordError, setPasswordError] = useState('');
        const [supplierSubmitted, setSupplierSubmitted] = useState(false);
        const [actualOtp, setActualOtp] = useState(''); // Store the actual OTP from database
        const [isSendingOtp, setIsSendingOtp] = useState(false); // Loading state for OTP sending
        const [isResendingOtp, setIsResendingOtp] = useState(false); // Loading state for OTP resending
        
        // Duplicate detection modal state
        const [showDuplicateModal, setShowDuplicateModal] = useState(false);
        const [duplicateMatches, setDuplicateMatches] = useState([]);
        const [showOtpVerification, setShowOtpVerification] = useState(false);
        const [selectedCompanyForVerification, setSelectedCompanyForVerification] = useState(null);
        const [verificationOtp, setVerificationOtp] = useState('');
        const [otpSentToEmail, setOtpSentToEmail] = useState('');
        
        // Incomplete application state
        const [incompleteApplications, setIncompleteApplications] = useState([]);
        const [showIncompleteModal, setShowIncompleteModal] = useState(false);
        const [selectedIncompleteApp, setSelectedIncompleteApp] = useState(null);
        const [isContinuingApplication, setIsContinuingApplication] = useState(false);
        
        // Get current API configuration
        const apiConfig = getCustomerPortalApi();

        // Load settings on component mount
        useEffect(() => {
            const loadSettings = async () => {
                try { 
                    const settingsResponse = await getSettings(); 
                    if (settingsResponse && settingsResponse.status === 1 && settingsResponse.data) {
                        setSettings(settingsResponse.data); 
                    } else {

                        setSettings(null);
                    }
                } catch (error) {
                    console.error('Failed to load settings:', error);
                    // Set a temporary fallback for testing
                    setSettings({ 
                        site_logo_preview: '/images/logo.png' // Fallback for testing
                    });
                }
            };
            loadSettings();
        }, []);

        // Load services independently when component mounts
        useEffect(() => {
            const loadServices = async () => {
                try {
                    const servicesResponse = await api.get('/api/supplier/get_services'); 
                    if (servicesResponse.data && servicesResponse.data.data.services) {
                        console.log('Services loaded from API - Total count:', servicesResponse.data.data.services.length);
                        console.log('First 3 services:', servicesResponse.data.data.services.slice(0, 3));
                        setServices(servicesResponse.data.data.services);
                    }
                } catch (error) {
                    console.error('Failed to load services:', error);
                }
            };
            loadServices();
        }, []);

        // Check for incomplete applications on component mount
        useEffect(() => {
            const checkIncompleteApplications = async () => {
                try {
             
                    const response = await api.get('/api/supplier/get_incomplete_applications');
           
                    
                    if (response.data && response.data.applications) {
            
                        if (response.data.applications.length > 0) {
                            setIncompleteApplications(response.data.applications);
                            setShowIncompleteModal(true); 
                        } else { 
                        }
                    } else {

                    }
                } catch (error) {

                }
            };
            
            // Add a small delay to ensure component is fully mounted
            setTimeout(checkIncompleteApplications, 500);
        }, []);

        // Function to continue with an incomplete application
        const continueIncompleteApplication = async (application) => {
            try { 
                
                // Set flag to indicate we're continuing an existing application
                setIsContinuingApplication(true);
                
                // Load the application data
                const response = await api.get(`/api/supplier/get_application_data/${application.reference}`);
                if (response.data && response.data.status === 1) {
                    const appData = response.data.data;
                    
                    // Populate form data
                    if (appData.profile) {
                        const profileData = typeof appData.profile === 'string' ? JSON.parse(appData.profile) : appData.profile;
                        setFormDataObject(profileData);
                    }
                    
                    // Set reference and progress
                    setReference(application.reference);
                    setProgress(appData.progress || 0);
                    
                    // Set selected services if available
                    if (appData.services) {
                        const servicesList = Array.isArray(appData.services) ? appData.services : appData.services.split(',');
                        const selectedServices = services.filter(service => 
                            servicesList.includes(service.value) || servicesList.includes(service.label)
                        );
                        setSelected(selectedServices);
                    }
                    
                    // Determine which step to go to based on progress
                    if (appData.progress >= 80) {
                        setStep(5); // Review step
                    } else if (appData.progress >= 60) {
                        setStep(4); // Experience step
                    } else if (appData.progress >= 40) {
                        setStep(3); // Services step
                    } else {
                        setStep(2); // Business info step
                    }
                    
                    setShowIncompleteModal(false); 
                } else {
                    console.error('Failed to load application data');
                }
            } catch (error) {
                console.error('Error loading incomplete application:', error);
            }
        };

        // Function to send OTP to company email for verification
        const sendVerificationOtp = async (company) => {
            setIsSendingOtp(true);
            try { 
                setNewRegisterFeedback('Sending verification code...');
                
                const response = await api.post('/api/supplier/send_verification_otp', {
                    email: company.email,
                    company_name: company.company_name,
                    reference: company.reference || ''
                });
                
                if (response.data && response.data.status === 1) {
                    setSelectedCompanyForVerification(company);
                    setOtpSentToEmail(company.email);
                    setShowOtpVerification(true);
                    setNewRegisterFeedback(`✓ Verification code sent to ${company.email}`); 
                } else {
                    setNewRegisterFeedback('✗ Failed to send verification code. Please try again.');
                }
            } catch (error) {
                console.error('Error sending verification OTP:', error);
                setNewRegisterFeedback('✗ Error sending verification code. Please try again.');
            } finally {
                setIsSendingOtp(false);
            }
        };

        // Function to verify OTP and continue with existing application
        const verifyOtpAndContinue = async () => {
            try {
                if (!verificationOtp || verificationOtp.length < 4) {
                    setNewRegisterFeedback('Please enter a valid verification code.');
                    return;
                }
 
                setNewRegisterFeedback('Verifying code...');
                
                const response = await api.post('/api/supplier/verify_company_otp', {
                    email: selectedCompanyForVerification.email,
                    otp: verificationOtp,
                    reference: selectedCompanyForVerification.reference || ''
                });
                
                if (response.data && response.data.status === 1) { 
                    
                    // Set flag to skip duplicate check
                    setIsContinuingApplication(true);
                    
                    // If there's application data, load it
                    if (response.data.application_data) {
                        const appData = response.data.application_data;
                        
                        // Populate form data
                        if (appData.profile) {
                            const profileData = typeof appData.profile === 'string' ? JSON.parse(appData.profile) : appData.profile;
                            setFormDataObject(profileData);
                        }
                        
                        // Set reference and progress
                        setReference(appData.reference || selectedCompanyForVerification.reference);
                        setProgress(appData.progress || 40); // Default to 40% (Step 3)
                        
                        // Set selected services if available
                        if (appData.services) {
                            const servicesList = Array.isArray(appData.services) ? appData.services : appData.services.split(',');
                            const selectedServices = services.filter(service => 
                                servicesList.includes(service.value) || servicesList.includes(service.label)
                            );
                            setSelected(selectedServices);
                        }
                    } else {
                        // No existing application data, set reference and go to step 3
                        setReference(selectedCompanyForVerification.reference || (new Date().toISOString().slice(2,10).replace(/-/g,'') + '-' + String(Math.floor(Math.random()*10000)).padStart(4,'0')));
                        setProgress(40);
                    }
                    
                    // Close modals and go to Step 3
                    setShowDuplicateModal(false);
                    setShowOtpVerification(false);
                    setStep(3);
                    setNewRegisterFeedback(''); 
                } else {
                    setNewRegisterFeedback(response.data.message || 'Invalid verification code. Please try again.');
                }
            } catch (error) {
                console.error('Error verifying OTP:', error);
                setNewRegisterFeedback('Error verifying code. Please try again.');
            }
        };

        // Function to handle company verification button click
        const handleVerifyCompany = (company) => {
            setSelectedCompanyForVerification(company);
            sendVerificationOtp(company);
        };

        // Custom validation function for file inputs
        const validateFileInputs = () => {
            const formElement = document.getElementById('supplier-registration-form');
            if (!formElement) return true;

            const fileInputs = formElement.querySelectorAll('input[type="file"][required]');
            let allValid = true;
 

            fileInputs.forEach((input, index) => {
                const hasRealFile = input.files && input.files.length > 0;
                const hasDemoFile = input.hasAttribute('data-demo-attached');
                

                
                if (hasRealFile || hasDemoFile) {
                    // File is valid (either real or demo)
                    input.setCustomValidity('');
                    input.classList.remove('invalid-file');
                } else {
                    // No file attached
                    input.setCustomValidity('Please select a file or use demo mode to attach a test file');
                    input.classList.add('invalid-file');
                    allValid = false;
                }
            });


            return allValid;
        };

        const handleSupplierRegisterSubmit = async (e) => { 
            e.preventDefault();
            
            setRegisterFeedback(
                <div className="flex justify-center items-center py-4">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-500"></div>
                </div>
            );

            if (!registerOTP) {
                // Initial registration - send vendor and email
                const formData = new FormData(e.currentTarget);  
                const formDataObj = {};
                formData.forEach((value, key) => (formDataObj[key] = value));  
                
                try {
                    const response = await axios.post(
                        `${apiConfig.baseUrl}/api/supplier-application/register`,
                        formDataObj,
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        }
                    );
                    
                    if (response.data && response.data.status === 1) { 
                        setRegisterFeedback("A one time pin has been sent to your email address"); 
                        setRegisterOTP(true);
                    } else {
                        setRegisterFeedback(response.data.message || "Registration failed");
                    }
                } catch (error) {
                    console.error('Registration error:', error);
                    setRegisterFeedback("There seems to be a technical glitch. Please try again later.");                    
                }   
            } else {
                // OTP verification stage
                const formData = new FormData(e.currentTarget);    
                const formDataObj = {};
                formData.forEach((value, key) => (formDataObj[key] = value));

                if (!formDataObj.pin || formDataObj.pin === "") {
                    setRegisterFeedback("You cannot submit an empty OTP!"); 
                    return;
                }
                
                try {
                    const response = await axios.post(
                        `${apiConfig.baseUrl}/api/supplier-application/register`,
                        formDataObj,
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        }
                    );
                    
                    if (response.data && response.data.status === 1) {  
                        setRegisterFeedback("OTP Verified. Logging you in..."); 
                        setTimeout(() => {
                            // Store the authentication token for the React app
                            localStorage.setItem('supplier_token', response.data.token);
                            localStorage.setItem('supplier_authenticated', 'true');
                            localStorage.setItem('supplier_needs_password_setup', 'true');
                            
                            // Redirect to React supplier dashboard instead of PHP
                            window.location.href = '/supplier/dashboard';
                        }, 2000);   
                    } else {
                        setRegisterFeedback(response.data.message || "OTP verification failed");
                    }
                } catch (error) {
                    console.error('OTP verification error:', error);
                    setRegisterFeedback("There seems to be a technical glitch. Please try again later.");                    
                }  
            }
        };

        // Simplified handler for demo purposes
        const handleStepProgression = async (e) => {
        e.preventDefault();
        
        let shouldProceed = true; // Flag to control progression
        
        // Basic validation based on step
        if (step === 2) {
            const formData = new FormData(e.target);
            
            // Merge controlled state data with form data
            Object.keys(formDataObject).forEach(key => {
                if (formDataObject[key]) {
                    formData.set(key, formDataObject[key]);
                }
            });
            
            const requiredFields = ['Company_Registered_Name', 'BP_Name', 'Company_Reg', 'Contact_Person', 'E_Mail'];
            
            for (let field of requiredFields) {
                if (!formData.get(field) || formData.get(field).trim() === '') {
                    setNewRegisterFeedback(`Please fill in the required field: ${field.replace(/_/g, ' ')}`);
                    return;
                }
            }
            
            // Check for duplicate companies before proceeding (skip if continuing existing application)
            if (!isContinuingApplication) {
                setNewRegisterFeedback('Checking for duplicate companies...'); 
                try {
                    const duplicateCheckData = Object.fromEntries(formData.entries()); 
                    
                    const duplicateResponse = await api.post('/api/supplier/check_duplicate', duplicateCheckData);
 
                    
                    if (duplicateResponse.data.data.is_duplicate === true) { 
                        const matches = duplicateResponse.data.data.matches; 
                        // Show duplicate modal instead of text feedback
                        setDuplicateMatches(matches);
                        setShowDuplicateModal(true);
                        setNewRegisterFeedback(''); // Clear any existing feedback
                        
                        shouldProceed = false; // Block progression 
                    } else {

                    }
                    
                    // No duplicates found, clear the checking message and continue
                    if (shouldProceed) { 
                        setNewRegisterFeedback('');
                    }
                    
                } catch (error) {
                    console.error('Error checking for duplicates:', error);
                    // Log the error but don't block the registration

                    setNewRegisterFeedback(''); // Clear any checking message
                }
            } else {

                setNewRegisterFeedback(''); // Clear any existing feedback
            }
            
            // Only proceed with Step 2 processing if no duplicates found
            if (shouldProceed) {
                // Store form data and generate reference
                setReviewData(prev => ({
                    ...prev,
                    companyName: formData.get('Company_Registered_Name') || '',
                    regNumber: formData.get('Company_Reg') || '',
                    contactPerson: formData.get('Contact_Person') || '',
                    email: formData.get('E_Mail') || '',
                    phone: formData.get('Cellphone') || '',
                    vat: formData.get('VAT_Number') || ''
                }));
                
                // Generate reference ID by calling startApplication API if we don't have one
                if (!reference || reference === 0) {
                    try {
                        // Log the form data being sent 
                        for (let [key, value] of formData.entries()) {

                        }
                        
                        const startResponse = await api.post(`/api/start_application`, formData);
                        if (startResponse.data && startResponse.data.reference) {
                            setReference(startResponse.data.reference); 
                        }
                        
                        // Only set services if not already loaded or if new services have coida property
                        if (startResponse.data && startResponse.data.services && services.length === 0) {
                            console.log('Setting services from start_application (Step 2)');
                            setServices(startResponse.data.services); 
                        }
                    } catch (error) {
                        console.error('Error generating reference:', error);
                        setNewRegisterFeedback('Error generating application reference. Please try again.');
                        shouldProceed = false;
                    }
                }
            }
        }
        
        if (step === 3) {
            if (selected.length === 0) {
                setNewRegisterFeedback('Please select at least one service to continue.');
                return;
            }
            if (selected.length > 5) {
                setNewRegisterFeedback('Please select a maximum of 5 services.');
                return;
            }
        }
        
        if (step === 4) {
            // Custom validation for file inputs (accepts both real files and demo files)
            const filesValid = validateFileInputs();
            if (!filesValid) {
                setNewRegisterFeedback('Please attach all required documents.');
                return;
            }
        }
        
        // Clear any previous feedback (only if we should proceed)
        if (shouldProceed) {
            setNewRegisterFeedback('');
        } 
        
        // Only progress to next step if validation passed and no duplicates found
        if (shouldProceed && step < 5) { 
            const nextStep = step + 1;
            const newProgress = nextStep * 20;
            setStep(nextStep);
            setProgress(newProgress);
        } else if (shouldProceed && step === 5) {
            // Step 5: Submit supplier data and move to OTP verification
            await handleSupplierSubmission(e.target);
        } else {

        }
        // Step 6 is the success page - no progression needed
        };

        // Handle supplier data submission (Step 5 -> Step 6)
        const handleSupplierSubmission = async (formElement) => {
        setSubmitStatus({ type: 'loading', message: 'Submitting your application...' });
        
        try {
            // Ensure we have a reference ID
            let submissionReference = reference;
            if (!submissionReference || submissionReference === 0) {
                // Generate a short unique reference instead of Date.now() to avoid JS precision issues
                submissionReference = new Date().toISOString().slice(2,10).replace(/-/g,'') + '-' + String(Math.floor(Math.random()*10000)).padStart(4,'0');
            }
            
            // Process file uploads first (like original implementation)
            setSubmitStatus({ type: 'loading', message: 'Uploading files...' });
            let file_check = {}; 
            for (let index in attachments) {
                const attachment = attachments[index]; 
                
                if (attachment && attachment.name !== undefined) {
                    // Check if this is a demo file or real file
                    if (attachment.demo === true) {
                        // Demo file - just mark as successful without uploading
                        file_check[index] = "2"; // Mark as successfully "uploaded" 
                    } else if (attachment instanceof File) {
                        // Real file - upload it
                        const formData = new FormData();
                        formData.append("file", attachment, attachment.name);
                        
                        let name = businessType[index] !== undefined ? businessType[index] : index;
                        formData.append("reference", submissionReference);
                        formData.append("name", name);
                  
                        
                        try {
                            const uploadResponse = await api.post(`/api/upload_file`, formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            }); 
                            if (uploadResponse.data && uploadResponse.data.status == 1) {
                                file_check[index] = "2"; // Successfully uploaded 
                            } else {
                                file_check[index] = "0"; // Failed to upload 
                            }
                        } catch (uploadError) {
                            console.error(`File upload failed for ${name}:`, uploadError);
                            file_check[index] = "0"; // Failed to upload
                        }
                    } else {
                        // Invalid attachment type
                        console.error(`Invalid attachment type for index ${index}:`, attachment);
                        file_check[index] = "0";
                    }
                } else {
                    file_check[index] = "0"; // No file selected
                }
            }
            
            // Update formFiles with the upload results
            setFormFiles(file_check);
            
            // Step 1: Call start_application with form data and services (like original)
            setSubmitStatus({ type: 'loading', message: 'Processing application...' });
            const startData = new FormData();
            startData.append("reference", submissionReference);
            startData.append("Group_Code", selected.map(a => a.value).toString());
            
            // Append individual form fields like the original
            for (var key in formDataObject) {
                if (formDataObject[key] !== undefined && formDataObject[key] !== null) {
                    startData.append(key, formDataObject[key]);
                }
            }
             
            const startResponse = await api.post(`/api/start_application`, startData);
            
            // Only set services if not already loaded or if new services have coida property
            if (startResponse.data && startResponse.data.services && services.length === 0) {
                console.log('Setting services from start_application (Submission)');
                setServices(startResponse.data.services); 
            }
            
            if (startResponse.data && startResponse.data.status === 1) {
                // Step 2: Call complete_application (like original)
                const completeData = new FormData(formElement);
                completeData.append("reference", submissionReference);
                completeData.append("profile", JSON.stringify(formDataObject));
                completeData.append("files", JSON.stringify(businessType));
                completeData.append("services", selected.map(a => a.value)); 
                completeData.append("attached", JSON.stringify(file_check)); // Use the actual upload results
                
                // Add declaration data
                completeData.append('Silulumanzi_Employee', Silulumanzi_Employee);
                completeData.append('Silulumanzi_Recent_Employee', Silulumanzi_Recent_Employee);
                completeData.append('Silulumanzi_Employee_Relative', Silulumanzi_Employee_Relative);
                completeData.append('Silulumanzi_Official_Relationship', Silulumanzi_Official_Relationship);
                completeData.append('Voluntary_Disclosure', Voluntary_Disclosure);
                completeData.append('Hazardous_Substances', Hazardous_Substances); 
                const completeResponse = await api.post(`/api/complete_application`, completeData);
                
                if (completeResponse.data && completeResponse.data.status === 1) {
                    setSubmitStatus({ 
                        type: 'success', 
                        message: 'Supplier data submitted successfully! Please verify your email to complete registration.' 
                    });
                    
                    // Move to step 6 (OTP verification and account setup)
                    setSupplierSubmitted(true);
                    setStep(6);
                    setProgress(100);
                    
                    // Send OTP email for verification
                    await sendOtpEmail();
                } else {
                    throw new Error(completeResponse.data?.message || 'Supplier submission failed');
                }
            } else {
                throw new Error(startResponse.data?.message || 'Start application failed');
            }
        } catch (error) {
            console.error('Submission error:', error);
            setSubmitStatus({ 
                type: 'error', 
                message: error.message || 'Submission failed. Please try again or contact support.' 
            });
        }
        };

        // Auto-populate function for current section
        const populateCurrentSection = () => {
            setFormDataObject(prev => ({
                ...prev,
                Company_Registered_Name: "Quantum Innovations Tech (Pty) Ltd",
                Holding_Company_Name: "Quantum Innovations Tech (Pty) Ltd",
                BP_Name: "Quantum Innovations Tech (Pty) Ltd",
                Company_Reg: "2024/789123/07",
                Vat_Registration: "4789123456",
                Supplier_Site: "Quantum Innovations Tech",
                Contact_Person: "Michael Chen",
                E_Mail: "michael.chen@quantuminnovations.co.za",
                Business_Web_Address: "www.quantuminnovations.co.za",
                Business_Phone: "011 234 5678",
                Business_Fax: "011 234 5679",
                Tel: "011 345 6789",
                Mobile_Phone: "084 567 8901",
                Number_of_Employees: "11-50",
                Annual_Turnover: "R5 - R20 million",
                Country: "South Africa",
                Address: "789 Innovation Hub, Fourways",
                City: "Fourways",
                Settlement_Discount: "Yes",
                Settlement_Discount_Percentage: "3.0",
                Preferred_Correspondence_Method: "Email",
                Physical_Address_Line1: "789 Innovation Hub",
                Physical_City: "Fourways",
                Physical_Postal_Code: "2055",
                Postal_Address_Line1: "PO Box 12345",
                Postal_City: "Fourways",
                Postal_Code: "2055",
                // Document-related fields
                BBBEE_Type: "Generic",
                BBBEE_Level: "Level 3",
                BBBEE_Expiration_Date: "2025-12-31",
                Tax_Certification_Number: "9871234567",
                Tax_Certificate_Expiry_Date: "2025-06-30",
                COIDA_Certificate_Number: "WCC987654321",
                COIDA_Certificate_Expiry_Date: "2025-09-15"
            }));
        };

        const autoSelectServices = () => {
            if (services && services.length > 0) {
                // Select first 3-5 services for testing
                const testServices = services.slice(0, Math.min(5, services.length));
                setSelected(testServices);
            }
        };

        // Auto-attach demo files function
        const attachDemoFiles = async () => {
            try {
                // Create a reference to the form element to add files
                const formElement = document.getElementById('supplier-registration-form');
                if (!formElement) { 
                    return;
                }

                // Get the current business type to determine which files to attach
                const currentBusinessType = formDataObject?.Business_Type || '';
                const documentTypes = currentBusinessType.split('|') || []; 

                // Get all file inputs
                const fileInputs = formElement.querySelectorAll('input[type="file"]'); 

                if (fileInputs.length === 0) {
                    alert('No file inputs found on the form.');
                    return;
                }

                let successCount = 0;
                const newAttachments = { ...attachments };

                // Create demo files for each input (except Tax Certificate)
                for (let i = 0; i < fileInputs.length; i++) {
                    try {
                        const input = fileInputs[i];
                        const documentType = documentTypes[i] || `Document_${i + 1}`;
                        
                        // Get the label text to check if this is a Tax Certificate field
                        const label = input.parentNode.querySelector('label');
                        const labelText = label ? label.textContent : '';
                        
                        // Skip "Valid SARS TAX Pin Certificate" field so user can test real file upload
                        if (labelText.includes('SARS TAX Pin Certificate') || 
                            labelText.includes('Tax Certificate') ||
                            documentType.includes('SARS TAX Pin Certificate')) { 
                            continue;
                        }
                        
                        const fileName = `demo_${documentType.toLowerCase()}_${Date.now()}.pdf`;
                        const fileSize = 1024 * (50 + Math.floor(Math.random() * 200)); // 50-250KB

                        // Create metadata for the demo file
                        input.setAttribute('data-demo-attached', 'true');
                        input.setAttribute('data-demo-file', fileName);
                        input.setAttribute('data-demo-size', fileSize.toString());
                        
                        // Apply visual styling
                        input.classList.add('demo-file-attached');
                        input.classList.remove('invalid-file');
                        
                        // Add visual indicator
                        let indicator = input.parentNode.querySelector('.demo-file-indicator');
                        if (!indicator) {
                            indicator = document.createElement('div');
                            indicator.className = 'demo-file-indicator';
                            input.parentNode.insertBefore(indicator, input.nextSibling);
                        }
                        
                        indicator.innerHTML = `
                            <div style="margin-top: 4px; padding: 8px; background: #f0fdf4; border: 1px solid #10b981; border-radius: 6px; font-size: 12px; color: #065f46;">
                                <strong>📄 Demo File Attached:</strong><br/>
                                <span style="font-family: monospace;">${fileName}</span><br/>
                                <span style="color: #6b7280;">Size: ${(fileSize / 1024).toFixed(1)} KB | Type: PDF | Demo Mode</span>
                            </div>
                        `;
                        
                        // Update the attachments state
                        newAttachments[i] = {
                            name: fileName,
                            size: fileSize,
                            type: 'application/pdf',
                            demo: true,
                            documentType: documentType
                        };
                         
                        successCount++;
                        
                    } catch (error) {
                        console.error(`Error creating demo file ${i + 1}:`, error);
                    }
                }
                
                // Update the attachments state
                setAttachments(newAttachments);

                if (successCount > 0) { 
                    alert(`✅ Attached ${successCount} demo PDF files!\n\nDemo files are now attached and the form validation will accept them. You can proceed to the next step.`);
                    
                    // Trigger validation check to update form state
                    validateFileInputs();
                } else {
                    alert(`❌ Failed to attach any files.`);
                }
                
            } catch (error) {
                console.error('Error attaching demo files:', error);
                alert(`❌ Error attaching demo files: ${error.message}`);
            }
        };

        const clearAllData = () => {
            setFormDataObject({});
            setSelected([]);
            setSameAsPhysical(false);
            
            // Clear demo file indicators
            const demoIndicators = document.querySelectorAll('.demo-file-indicator');
            demoIndicators.forEach(indicator => {
                indicator.remove();
            });
            
            // Reset file input styling and validation
            const fileInputs = document.querySelectorAll('input[type="file"]');
            fileInputs.forEach(input => {
                // Remove demo file attributes
                input.removeAttribute('data-demo-attached');
                input.removeAttribute('data-demo-file');
                input.removeAttribute('data-demo-size');
                
                // Remove styling classes
                input.classList.remove('demo-file-attached', 'invalid-file');
                
                // Reset custom validity to re-enable validation
                input.setCustomValidity('');
                
                // Clear the files if possible
                try {
                    input.value = '';
                } catch (e) {
                    console.warn('Could not clear file input value');
                }
            });
            
            // Clear attachments state
            setAttachments({});
        };

        // Send OTP email for verification
        const sendOtpEmail = async () => {
            setIsSendingOtp(true);
            try {
                // Get email from form data or review data
                const email = reviewData.email || formDataObject.E_Mail;
                
                if (!email) {
                    console.error('No email found for OTP');
                    setSubmitStatus({ 
                        type: 'error', 
                        message: 'No email address found. Please complete your profile.' 
                    });
                    return;
                }

                // For new supplier registration, we need to create a user account request
                // This should call an endpoint that generates an OTP for new user creation
                const response = await api.post('/api/supplier/create_user_account', {
                    email: email,
                    reference: reference
                });

                if (response.data && response.data.status === 1) {
                    setOtpSent(true);
                    setSubmitStatus({ 
                        type: 'success', 
                        message: `Verification code sent to ${email}` 
                    });
                    
                    // In debug mode, fetch the actual OTP for debugging
                    if (settings?.debug_mode === '1') {
                        setTimeout(() => {
                            fetchActualOtp(email);
                        }, 1500); // Small delay to ensure OTP is saved
                    }
                } else { 
                    // For development, let's create a mock OTP
                    if (process.env.NODE_ENV === 'development') {
                        setOtpSent(true);
                        setActualOtp('12345'); // Mock OTP for testing

                        setSubmitStatus({ 
                            type: 'success', 
                            message: `Verification code sent to ${email} (Dev Mode)` 
                        });
                    } else {
                        setSubmitStatus({ 
                            type: 'error', 
                            message: 'Failed to send verification code. Please try again.' 
                        });
                    }
                }
            } catch (error) {
                console.error('Error sending OTP:', error);
                // For development, let's create a mock OTP if the API fails
                if (process.env.NODE_ENV === 'development') {
                    setOtpSent(true);
                    setActualOtp('12345'); // Mock OTP for testing

                    setSubmitStatus({ 
                        type: 'success', 
                        message: 'Verification code sent (Dev Mode)' 
                    });
                } else {
                    setSubmitStatus({ 
                        type: 'error', 
                        message: 'Error sending verification code. Please try again.' 
                    });
                }
            } finally {
                setIsSendingOtp(false);
            }
        };

        // Fetch the actual OTP from database for debugging
        const fetchActualOtp = async (email) => {
            try {
                if (!email) {
                    email = reviewData.email || formDataObject.E_Mail;
                }
                
                const response = await api.post('/api/supplier/get_otp', {
                    email: email
                });

                if (response.data && response.data.status === 1 && response.data.otp) {
                    setActualOtp(response.data.otp); 
                } else {

                }
            } catch (error) {
                console.error('Error fetching actual OTP:', error);
                // Non-critical error, don't show to user
            }
        };

        // Handle OTP verification
        const handleVerifyOtp = async () => {
            try {
                const email = reviewData.email || formDataObject.E_Mail;
                
                const response = await api.post('/api/supplier/verify_new_supplier_otp', {
                    email: email,
                    otp: otpCode
                });

                if (response.data && response.data.status === 1) {
                    setOtpVerified(true);
                    setSubmitStatus({ 
                        type: 'success', 
                        message: 'Email verified successfully! Please setup your password.' 
                    });
                } else {
                    setSubmitStatus({ 
                        type: 'error', 
                        message: response.data?.message || 'Invalid verification code. Please try again.' 
                    });
                }
            } catch (error) {
                console.error('Error verifying OTP:', error);
                // Check if the error response contains the API message (incorrect OTP)
                if (error.response && error.response.data && error.response.data.message) {
                    setSubmitStatus({ 
                        type: 'error', 
                        message: error.response.data.message 
                    });
                } else {
                    // Only show system error for actual network/system failures
                    setSubmitStatus({ 
                        type: 'error', 
                        message: 'System error occurred. Please try again or contact support.' 
                    });
                }
            }
        };

        // Handle resending OTP
        const handleResendOtp = async () => {
            setIsResendingOtp(true);
            setOtpCode('');
            setSubmitStatus({ 
                type: 'info', 
                message: 'Resending verification code...' 
            });
            try {
                await sendOtpEmail();
            } finally {
                setIsResendingOtp(false);
            }
        };

        // Handle account creation with password
        const handleCreateAccount = async () => {
            // Validate passwords
            if (password !== confirmPassword) {
                setPasswordError('Passwords do not match');
                return;
            }
            
            if (password.length < 6) {
                setPasswordError('Password must be at least 6 characters long');
                return;
            }

            setPasswordError('');

            try {
                const email = reviewData.email || formDataObject.E_Mail;
                const contactPerson = formDataObject.Contact_Person || '';
                
                const response = await api.post('/api/supplier/setup_password', {
                    email: email,
                    password: password,
                    name: contactPerson,
                    position: 'Supplier Representative'
                });

                if (response.data && response.data.status === 1) {
                    // Account created successfully, redirect to dashboard
                    setSubmitStatus({ 
                        type: 'success', 
                        message: 'Account created successfully! Redirecting to dashboard...' 
                    });
                    
                    // Store authentication data and redirect
                    localStorage.setItem('supplier_token', response.data.token || email);
                    localStorage.setItem('needs_password_setup', 'false');
                    
                    setTimeout(() => {
                        // Navigate to supplier dashboard using React Router
                        navigate('/supplier/dashboard');
                    }, 2000);
                } else {
                    setPasswordError(response.data?.message || 'Failed to create account');
                }
            } catch (error) {
                console.error('Error creating account:', error);
                setPasswordError('Account creation failed. Please try again.');
            }
        };

        return ( 
        <div className="min-h-screen" style={{backgroundColor: 'var(--bg-primary)'}}>
            {/* Custom CSS for file validation feedback */}
            <style>{`
                .invalid-file {
                    border-color: #dc2626 !important;
                    background-color: #fef2f2 !important;
                }
                .demo-file-attached {
                    border-color: #10b981 !important;
                    background-color: #f0fdf4 !important;
                }
            `}</style>
            
            {/* Header */}
            <div style={{background: 'var(--gradient-primary)'}} className="text-white shadow-lg">
                <div className="max-w-6xl mx-auto px-6 py-6">
                    <div className="flex items-center justify-between">
                        <div>
                            <h1 className="text-3xl font-bold text-white drop-shadow-sm">New Supplier Application</h1>
                            <p className="text-white/90 mt-1 font-medium drop-shadow-sm">Complete your registration to become a verified supplier</p>
                        </div>
                        <Link 
                            to="/supplier/login" 
                            className="text-white hover:text-white/80 transition-colors flex items-center space-x-2 px-4 py-2 rounded-lg hover:bg-white/20 border border-white/30 hover:border-white/50 font-medium"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                            <span>Back to Login</span>
                        </Link>
                    </div>
                    
                    {/* Progress Bar */}
                    <div className="mt-6">
                        <div className="flex justify-between text-sm text-white/90 font-medium mb-2">
                            <span>Step {step} of 6</span>
                            <span>{Math.round(progress)}% Complete</span>
                        </div>
                        <div className="w-full bg-white/20 rounded-full h-3 shadow-inner">
                            <div 
                                className="bg-white h-3 rounded-full transition-all duration-300 ease-out shadow-sm"
                                style={{width: `${progress}%`}}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="max-w-6xl mx-auto px-6 py-8">
                <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
                    
                    {/* Sidebar Navigation */}
                    <div className="lg:col-span-1">
                        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 sticky top-8">
                            {/* Company Logo */}
                            {settings?.site_logo_preview ? (
                                <div className="mb-4 text-center">
                                    <img 
                                        src={settings.site_logo_preview} 
                                        alt="Company Logo" 
                                        className="h-12 w-auto mx-auto"
                                        onError={(e) => {

                                            e.target.style.display = 'none';
                                        }} 
                                    />
                                </div>
                            ) : settings === null ? (
                                <div className="mb-4 text-center text-xs text-gray-500">
                                    Loading logo...
                                </div>
                            ) : (
                                <div className="mb-4 text-center text-xs text-gray-500">
                                    No logo configured
                                </div>
                            )}
 
                            <h3 className="text-sm font-semibold text-gray-900 mb-4 uppercase tracking-wide center">Application Steps</h3>
                            <div className="space-y-3">
                                {[
                                    { num: 1, title: "Introduction", icon: "📋" },
                                    { num: 2, title: "Business Info", icon: "🏢" },
                                    { num: 3, title: "Services", icon: "🔧" },
                                    { num: 4, title: "Experience", icon: "📊" },
                                    { num: 5, title: "Review", icon: "👀" },
                                    { num: 6, title: "Account Setup", icon: "✅" }
                                ].map((stepItem) => (
                                    <div 
                                        key={stepItem.num}
                                        className={`flex items-center space-x-3 p-3 rounded-lg transition-colors ${
                                            step === stepItem.num 
                                                ? 'bg-blue-50 border-l-4 border-blue-500 text-blue-700' 
                                                : step > stepItem.num 
                                                    ? 'text-green-600' 
                                                    : 'text-gray-500'
                                        }`}
                                    >
                                        <span className="text-lg">{stepItem.icon}</span>
                                        <div>
                                            <div className="text-sm font-medium">{stepItem.title}</div>
                                            <div className="text-xs opacity-75">Step {stepItem.num}</div>
                                        </div>
                                        {step > stepItem.num && (
                                            <svg className="w-4 h-4 text-green-500 ml-auto" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                            </svg>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Main Form Area */}
                    <div className="lg:col-span-3">
                        <div className="bg-white rounded-xl shadow-sm border border-gray-200">
                            
                            {/* Error/Feedback Message */}
                            {newRegisterFeedback && (
                                <div className="p-6 border-b border-gray-200">
                                    <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                                        <div className="flex items-center">
                                            <svg className="w-5 h-5 text-amber-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16c-.77.833.192 2.5 1.732 2.5z" />
                                            </svg>
                                            <span className="text-amber-800 text-sm">{newRegisterFeedback}</span>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Form Content */}
                            <form id="supplier-registration-form" onSubmit={handleStepProgression} ref={formRef} className="p-8" noValidate>
                                
                                {/* Step 1: Introduction */}
                                {step === 1 && (
                                    <div className="space-y-6">
                                        <div className="text-center">
                                            <div className="mx-auto w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                                                <svg className="w-10 h-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                </svg>
                                            </div>
                                            <h2 className="text-2xl font-bold text-gray-900 mb-2">Introduction</h2>
                                            <p className="text-gray-600">Silulumanzi hereby invites current and prospective suppliers to apply to be verified and registered on the Company Supplier Database. All suppliers must be validated and registered to do business with us.</p>
                                        </div>
                                        
                                        <div className="bg-gray-50 rounded-xl p-4 space-y-4">
                              
                                            
                                            <div>
                                                <h3 className="text-lg font-semibold text-gray-900 mb-3">Key Requirements</h3>
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                                    {[
                                                        { text: "Complete all form sections in full" },
                                                        { text: "Submit all required documentation" },
                                                        { text: "Select up to 5 services (Step 3)" },
                                                        { text: "Complete trade experience section" },
                                                        { text: "Fill out business declarations" },
                                                        { text: "Contact (013) 752 6839 for assistance" }
                                                    ].map((item, index) => (
                                                        <div key={index} className="flex items-start">
                                                            <span className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                                                            <p className="text-sm text-gray-700 leading-5">{item.text}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            
                                            <div className="mt-6 pl-5 border-l-4 border-blue-300">
                                                <p className="text-blue-800 text-sm"><strong>📧 Note:</strong> We will inform you of your application status via email.</p>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Step 2: Business Information */}
                                {step === 2 && (
                                    <div className="space-y-8">
                                        <div className="text-center">
                                            <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-4">
                                                <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H3m2 0h3M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                                </svg>
                                            </div>
                                            <h2 className="text-2xl font-bold text-gray-900 mb-2">Business Information</h2>
                                            <p className="text-gray-600">Provide your complete company details and business information</p>
                                        </div>

                                        {/* Business Type Selection */}
                                        <div className="bg-blue-50 rounded-xl p-4 space-y-3"> 
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    Business Type <span className="text-red-500">*</span>
                                                </label>
                                                <select 
                                                    name="Business_Type" 
                                                    value={formDataObject.Business_Type || ''}
                                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                                                    onChange={(e) => {
                                                        // Update formDataObject for form submission
                                                        setFormDataObject(prev => ({ ...prev, Business_Type: e.target.value }));
                                                        
                                                        if(e.target.value !== ""){
                                                            let files = e.target.value.split("|");
                                                            setBusinessType(files);
                                                            let attach = {};
                                                            files.forEach((file, i) => {
                                                                attach[i] = {};
                                                            });
                                                            setAttachments(attach); 
                                                        } else {
                                                            setBusinessType([]);
                                                        }                          
                                                    }}
                                                >
                                                    <option value="">Please Select</option>
                                                    <option value="Certified Certificate of incorporation CK1|Latest Certified Copy of Rates & Taxes Statement or Lease agreement or Municipal/ Silulumanzi Account|Valid SARS TAX Pin Certificate|Clear Certified ID Copies (not older than 3 months) of Members|Valid BBBEE Certificate|Proof of Banking">Close Corporation</option>
                                                    <option value="Latest Certified Copy of Rates & Taxes Statement or Lease agreement or Municipal/ Silulumanzi Account|Valid Partnership Pin Tax Certificate|Clear Certified ID Copies (not older than 3 months) of Partners|Valid BBBEE Certificate|Proof of Banking">Partnership</option>
                                                    <option value="Certified Certificate of Incorporation COR 14.1|Latest Certified Copy of Rates & Taxes Statement or Lease agreement or Municipal/ Silulumanzi Account|Valid SARS TAX Pin Certificate|Clear Certified ID Copies (not older than 3 months) of Partners|Valid BBBEE Certificate/ Sworn Affidavit|Proof of Banking">Public Company Ltd</option>
                                                    <option value="Certified Certificate of Incorporation COR 14.3|Latest Certified Copy of Rates & Taxes Statement or Lease agreement or Municipal/ Silulumanzi Account|Valid SARS TAX Pin Certificate|Clear Certified ID Copies (not older than 3 months) of Partners|Valid BBBEE Certificate/ Sworn Affidavit|Proof of Banking">Private Company (Pty) Ltd</option>
                                                    <option value="Deed of Trust Agreement|Latest Certified Copy of Rates & Taxes Statement or Lease agreement or Municipal/ Silulumanzi Account|Valid SARS TAX Pin Certificate|Clear Certified ID Copies (not older than 3 months) of Trustees|Valid BBBEE Certificate|Proof of Banking">Business Trust</option>
                                                    <option value="Certified Certificate of Incorporation Section 21|Latest Certified Copy of Rates & Taxes Statement or Lease agreement or Municipal/ Silulumanzi Account|Valid NPO Pin Tax Certificate / Proof of Exemption|Clear Certified ID Copy (not older than 3 months)|Valid BBBEE Certificate|Proof of Banking">Non-Profit Organisation</option>
                                                    <option value="Registrar of Close Corporation & Companies|Local Authority|Receiver of Revenue (SARS)">Institution</option>
                                                </select>
                                            </div>

                                            {businessType.length > 0 && (
                                                <div className="bg-blue-100 border border-blue-200 rounded-lg p-4">
                                                    <h6 className="font-semibold text-blue-800 mb-2">Required Documents:</h6>
                                                    <ul className="space-y-1">
                                                        {businessType.map((item, index) => (
                                                            <li key={index} className="text-sm text-blue-700 flex items-start">
                                                                <span className="text-blue-500 mr-2">•</span>
                                                                {item}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>

                                        {/* Company Information Grid - Only show when business type is selected */}
                                        {formDataObject.Business_Type ? (
                                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                                            {/* Left Column */}
                                            <div className="space-y-6"> 

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Registered Company Name <span className="text-red-500">*</span>
                                                    </label>
                                                    <input 
                                                        type="text" 
                                                        name="Company_Registered_Name" 
                                                        required
                                                        value={formDataObject.Company_Registered_Name || ''}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            setFormDataObject(prev => ({
                                                                ...prev,
                                                                Company_Registered_Name: value,
                                                                // Auto-populate if not manually edited
                                                                ...(prev.Holding_Company_Name === prev.Company_Registered_Name || !prev.Holding_Company_Name ? { Holding_Company_Name: value } : {}),
                                                                ...(prev.BP_Name === prev.Company_Registered_Name || !prev.BP_Name ? { BP_Name: value } : {})
                                                            }));
                                                        }}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.Company_Registered_Name ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                        placeholder="Enter registered company name"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Holding Company Name
                                                    </label>
                                                    <input 
                                                        type="text" 
                                                        name="Holding_Company_Name" 
                                                        value={formDataObject.Holding_Company_Name || ''}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, Holding_Company_Name: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.Holding_Company_Name ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                        placeholder="Enter holding company name (if applicable)"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Trading Company Name <span className="text-red-500">*</span>
                                                    </label>
                                                    <input 
                                                        type="text" 
                                                        name="BP_Name" 
                                                        required
                                                        value={formDataObject.BP_Name || ''}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, BP_Name: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.BP_Name ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                        placeholder="Enter trading name"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Company Registration Number <span className="text-red-500">*</span>
                                                    </label>
                                                    <input 
                                                        type="text" 
                                                        name="Company_Reg" 
                                                        required
                                                        value={formDataObject.Company_Reg || ''}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, Company_Reg: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.Company_Reg ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                        placeholder="e.g., 2021/123456/07"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        VAT Registration Number
                                                    </label>
                                                    <input 
                                                        type="text" 
                                                        name="Vat_Registration" 
                                                        value={formDataObject.Vat_Registration || ''}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, Vat_Registration: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.Vat_Registration ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                        placeholder="e.g., 4123456789"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Site/Branch Name <span className="text-red-500">*</span>
                                                    </label>
                                                    <input 
                                                        type="text" 
                                                        name="Supplier_Site" 
                                                        required
                                                        value={formDataObject.Supplier_Site || ''}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, Supplier_Site: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.Supplier_Site ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                        placeholder="Enter site or branch name"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Number of Employees <span className="text-red-500">*</span>
                                                    </label>
                                                    <select 
                                                        name="Number_of_Employees" 
                                                        required 
                                                        value={formDataObject.Number_of_Employees || ''}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, Number_of_Employees: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.Number_of_Employees ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                    >
                                                        <option value="">Please Select</option>
                                                        <option>1-10</option>
                                                        <option>11-50</option>
                                                        <option>51-200</option>
                                                        <option>201-500</option>
                                                        <option>500+</option>
                                                    </select>
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Country <span className="text-red-500">*</span>
                                                    </label>
                                                    <select 
                                                        name="Country" 
                                                        required
                                                        value={formDataObject.Country || 'South Africa'}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, Country: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.Country ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                    >
                                                        <option value="South Africa">South Africa</option>
                                                        <option value="Botswana">Botswana</option>
                                                        <option value="Lesotho">Lesotho</option>
                                                        <option value="Namibia">Namibia</option>
                                                        <option value="Swaziland">Swaziland</option>
                                                        <option value="Zimbabwe">Zimbabwe</option>
                                                        <option value="Other">Other</option>
                                                    </select>
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Address <span className="text-red-500">*</span>
                                                    </label>
                                                    <input 
                                                        type="text" 
                                                        name="Address" 
                                                        required
                                                        value={formDataObject.Address || ''}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, Address: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.Address ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                        placeholder="Enter physical address"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        City <span className="text-red-500">*</span>
                                                    </label>
                                                    <input 
                                                        type="text" 
                                                        name="City" 
                                                        required
                                                        value={formDataObject.City || ''}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, City: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.City ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                        placeholder="Enter city"
                                                    />
                                                </div>
                                            </div>

                                            {/* Right Column */}
                                            <div className="space-y-6">
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Contact Person <span className="text-red-500">*</span>
                                                    </label>
                                                    <input 
                                                        type="text" 
                                                        name="Contact_Person" 
                                                        required
                                                        value={formDataObject.Contact_Person || ''}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, Contact_Person: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.Contact_Person ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                        placeholder="Primary contact person"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Business Email Address <span className="text-red-500">*</span>
                                                    </label>
                                                    <input 
                                                        type="email" 
                                                        name="E_Mail" 
                                                        required
                                                        value={formDataObject.E_Mail || ''}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, E_Mail: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.E_Mail ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                        placeholder="business@company.com"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Business Website
                                                    </label>
                                                    <input 
                                                        type="text" 
                                                        name="Business_Web_Address" 
                                                        value={formDataObject.Business_Web_Address || ''}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, Business_Web_Address: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.Business_Web_Address ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                        placeholder="www.company.com"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Business Phone Number <span className="text-red-500">*</span>
                                                    </label>
                                                    <input 
                                                        type="tel" 
                                                        name="Business_Phone" 
                                                        required
                                                        value={formDataObject.Business_Phone || ''}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, Business_Phone: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.Business_Phone ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                        placeholder="011 123 4567"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Business Fax Number
                                                    </label>
                                                    <input 
                                                        type="tel" 
                                                        name="Business_Fax" 
                                                        value={formDataObject.Business_Fax || ''}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, Business_Fax: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.Business_Fax ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                        placeholder="011 123 4567"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Telephone Number <span className="text-red-500">*</span>
                                                    </label>
                                                    <input 
                                                        type="tel" 
                                                        name="Tel" 
                                                        required
                                                        value={formDataObject.Tel || ''}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, Tel: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.Tel ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                        placeholder="011 123 4567"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Mobile Phone Number
                                                    </label>
                                                    <input 
                                                        type="tel" 
                                                        name="Mobile_Phone" 
                                                        value={formDataObject.Mobile_Phone || ''}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, Mobile_Phone: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.Mobile_Phone ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                        placeholder="083 123 4567"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        How do you prefer to be contacted?
                                                    </label>
                                                    <select 
                                                        name="Preferred_Correspondence_Method" 
                                                        value={formDataObject.Preferred_Correspondence_Method || ''}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, Preferred_Correspondence_Method: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.Preferred_Correspondence_Method ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                    >
                                                        <option value="">Please Select</option>
                                                        <option value="Email">Email</option>
                                                        <option value="Phone">Phone</option>
                                                    </select>
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Annual Turnover <span className="text-red-500">*</span>
                                                    </label>
                                                    <select 
                                                        name="Annual_Turnover" 
                                                        required 
                                                        value={formDataObject.Annual_Turnover || ''}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, Annual_Turnover: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.Annual_Turnover ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                    >
                                                        <option value="">Please Select</option>
                                                        <option>Under R1 million</option>
                                                        <option>R1 - R5 million</option>
                                                        <option>R5 - R20 million</option>
                                                        <option>R20 - R50 million</option>
                                                        <option>Over R50 million</option>
                                                    </select>
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Do you give Settlement Discount if payment is made within 30 days?
                                                    </label>
                                                    <select 
                                                        name="Settlement_Discount" 
                                                        value={formDataObject.Settlement_Discount || ''}
                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, Settlement_Discount: e.target.value }))}
                                                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                            formDataObject.Settlement_Discount ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                        }`}
                                                    >
                                                        <option value="">Please Select</option>
                                                        <option value="No">No</option>
                                                        <option value="Yes">Yes</option>
                                                    </select>
                                                </div>

                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        How many percent discount do you give?
                                                    </label>
                                                    <div className="relative">
                                                        <input 
                                                            type="number" 
                                                            name="Settlement_Discount_Percentage" 
                                                            value={formDataObject.Settlement_Discount_Percentage || ''}
                                                            onChange={(e) => setFormDataObject(prev => ({ ...prev, Settlement_Discount_Percentage: e.target.value }))}
                                                            className={`w-full px-4 py-3 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                                                                formDataObject.Settlement_Discount_Percentage ? 'bg-green-50 text-green-900 font-medium border-green-300' : 'bg-white text-gray-700'
                                                            }`}
                                                            placeholder="Enter percentage"
                                                        />
                                                        <span className="absolute right-3 top-3 text-gray-500">%</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        ) : (
                                        <div className="text-center py-12 bg-gray-50 rounded-xl border-2 border-dashed border-gray-300">
                                            <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H3m2 0h3M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                            </svg>
                                            <h3 className="mt-4 text-lg font-medium text-gray-900">Select a Business Type</h3>
                                            <p className="mt-2 text-sm text-gray-500">Please select your business type above to continue with the company information form.</p>
                                        </div>
                                        )}
                                    </div>
                                )}

                                {/* Step 3: Services Selection */}
                                {step === 3 && (
                                    <div className="space-y-6">
                                        {/* Services Display */}

                                        <div className="text-center">
                                            <div className="mx-auto w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                                                <svg className="w-10 h-10 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                </svg>
                                            </div>
                                            <h2 className="text-2xl font-bold text-gray-900 mb-2">Services & Products</h2>
                                            <p className="text-gray-600">Select the services and products you can provide</p>
                                        </div>

                                        <div className="bg-purple-50 rounded-xl p-6">
                                            <div className="flex items-center space-x-3 mb-4">
                                                <div className="bg-purple-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold">!</div>
                                                <div>
                                                    <h3 className="text-lg font-semibold text-gray-900">Service Selection</h3>
                                                    <p className="text-sm text-gray-600">You may select up to <span className="bg-purple-600 text-white px-2 py-1 rounded text-xs font-bold">5</span> services</p>
                                                </div>
                                            </div>

                                            {/* Selected Services Display */}
                                            {selected.length > 0 && (
                                                <div className="mb-6">
                                                    <h4 className="font-medium text-gray-800 mb-3">Selected Services:</h4>
                                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                                                        {selected.map((service, index) => (
                                                            index < 5 ? (
                                                                <div key={index} className="bg-green-100 border border-green-200 rounded-lg p-3">
                                                                    <div className="flex items-center space-x-2">
                                                                        <span className="bg-green-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold">{index + 1}</span>
                                                                        <span className="text-sm font-medium text-green-800">{service.value}</span>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div key={index} className="bg-red-100 border border-red-200 rounded-lg p-3">
                                                                    <span className="text-sm text-red-800">⚠️ You have exceeded the maximum number of services</span>
                                                                </div>
                                                            )
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {/* Simple Service Selection - Match Original */}
                                            <div className="services-selector">
                                                <label className="block text-sm font-medium text-gray-700 mb-3">
                                                    Available Services <span className="text-red-500">*</span>
                                                    <span className="text-xs text-gray-500 ml-2">({services?.length || 0} services available)</span>
                                                </label>
                                                <MultiSelect
                                                    options={services}
                                                    value={selected}
                                                    onChange={(newSelected) => {
                                                        console.log('Services selected:', newSelected);
                                                        setSelected(newSelected);
                                                    }}
                                                    labelledBy="Select"
                                                    hasSelectAll={false}
                                                    className="services-multiselect"
                                                />
                                                <p className="text-xs text-gray-500 mt-2">
                                                    Use the search box to find specific services or browse through the categories
                                                </p>
                                            </div>
                                        </div>

                                    </div>
                                )}

                                {/* Step 4: Document Upload */}
                                {step === 4 && (
                                    <div className="space-y-8">
                                        <div className="text-center">
                                            <div className="mx-auto w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mb-4">
                                                <svg className="w-10 h-10 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                </svg>
                                            </div>
                                            <h2 className="text-2xl font-bold text-gray-900 mb-2">Upload Documents</h2>
                                            <p className="text-gray-600">Upload all required supporting documents</p>
                                        </div>

                                        {/* Document Validity Information */}
                                        <div className="bg-blue-50 border border-blue-200 rounded-xl p-6">
                                            <div className="flex items-start space-x-3">
                                                <svg className="w-6 h-6 text-blue-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                                <div>
                                                    <h3 className="font-semibold text-blue-900 mb-2">Document Validity Requirements</h3>
                                                    <ul className="text-sm text-blue-800 space-y-1">
                                                        <li><strong>BEE Certificate:</strong> Not older than 12 months</li>
                                                        <li><strong>Proof of Banking:</strong> On bank letterhead, not older than 6 months</li>
                                                        <li><strong>Tax Clearance Certificate:</strong> Valid, not older than 12 months</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Required Documents from Business Type */}
                                        {businessType.length > 0 && (
                                            <div className="space-y-6">
                                                <h3 className="text-lg font-semibold text-gray-900">Required Documents</h3>
                                                {businessType.map((item, index) => (
                                                    <div key={index} className="bg-white border border-gray-200 rounded-xl p-6 space-y-4">
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-900 mb-3 bg-green-100 text-green-800 px-3 py-2 rounded-lg">
                                                                {item}
                                                            </label>
                                                            <input 
                                                                type="file" 
                                                                required
                                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                                                                onChange={(event) => {   
                                                                    let attach = {...attachments};
                                                                    attach[index] = event.target.files[0];
                                                                    setAttachments(attach);
                                                                }}
                                                            />
                                                        </div>

                                                        {/* Tax Certificate Additional Fields */}
                                                        {item.includes("Tax Certificate") && (
                                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 pt-4 border-t border-gray-200">
                                                                <div>
                                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                        Tax Certification Number <span className="text-red-500">*</span>
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="Tax_Certification_Number"
                                                                        value={formDataObject.Tax_Certification_Number || ''}
                                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, Tax_Certification_Number: e.target.value }))}
                                                                        required
                                                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                                                                        placeholder="Enter tax certification number"
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                        Tax Certificate Expiry Date <span className="text-red-500">*</span>
                                                                    </label>
                                                                    <input
                                                                        type="date"
                                                                        name="Tax_Certificate_Expiry_Date"
                                                                        value={formDataObject.Tax_Certificate_Expiry_Date || ''}
                                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, Tax_Certificate_Expiry_Date: e.target.value }))}
                                                                        required
                                                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* BBBEE Certificate Additional Fields */}
                                                        {item.includes("BBBEE Certificate") && (
                                                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4 pt-4 border-t border-gray-200">
                                                                <div>
                                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                        BBBEE Type <span className="text-red-500">*</span>
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="BBBEE_Type"
                                                                        value={formDataObject.BBBEE_Type || ''}
                                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, BBBEE_Type: e.target.value }))}
                                                                        required
                                                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                                                                        placeholder="e.g., Generic, QSE"
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                        BBBEE Level <span className="text-red-500">*</span>
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="BBBEE_Level"
                                                                        value={formDataObject.BBBEE_Level || ''}
                                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, BBBEE_Level: e.target.value }))}
                                                                        required
                                                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                                                                        placeholder="e.g., Level 1, Level 4"
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                        BBBEE Expiration Date <span className="text-red-500">*</span>
                                                                    </label>
                                                                    <input
                                                                        type="date"
                                                                        name="BBBEE_Expiration_Date"
                                                                        value={formDataObject.BBBEE_Expiration_Date || ''}
                                                                        onChange={(e) => setFormDataObject(prev => ({ ...prev, BBBEE_Expiration_Date: e.target.value }))}
                                                                        required
                                                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                        {/* Additional Documents Section */}
                        {(() => {
                            // Log services array state
                            console.log('Services array state:', {
                                servicesCount: services?.length || 0,
                                firstService: services?.[0],
                                sampleServices: services?.slice(0, 5), // Show first 5 services
                                selectedCount: selected?.length || 0
                            });
                            
                            // Match selected services with full service data from services array
                            const selectedWithFullData = selected.map(selectedService => {
                                const fullService = services.find(s => s.value === selectedService.value);
                                if (!fullService) {
                                    console.warn('Could not find full service data for:', selectedService.value);
                                }
                                return fullService || selectedService;
                            });
                            
                            const requiresCoida = selectedWithFullData.some(service => service.coida === 1);
                            const servicesRequiringCoida = selectedWithFullData.filter(s => s.coida === 1);
                            
                            console.log('COIDA Check:', {
                                requiresCoida,
                                servicesRequiringCoida: servicesRequiringCoida.map(s => s.label),
                                totalSelected: selected.length,
                                selectedWithFullData: selectedWithFullData.map(s => ({ 
                                    label: s.label, 
                                    value: s.value, 
                                    coida: s.coida 
                                }))
                            });
                            
                            return (formDataObject.Vat_Registration !== "" || requiresCoida) && (
                                <div className="space-y-6">
                                    <h3 className="text-lg font-semibold text-gray-900">Additional Required Documents</h3>                                                {/* VAT Registration Document (if applicable) */}
                                                {formDataObject.Vat_Registration !== "" && (
                                                    <div className="bg-white border border-gray-200 rounded-xl p-6">
                                                        <h4 className="font-semibold text-gray-900 mb-4">VAT Registration Document</h4>
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-900 mb-3 bg-green-100 text-green-800 px-3 py-2 rounded-lg">
                                                                VAT Registration Document
                                                            </label>
                                                            <input 
                                                                type="file" 
                                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                                                                onChange={(event) => {   
                                                                    let attach = {...attachments};
                                                                    attach["VAT Registration Certificate"] = event.target.files[0];
                                                                    setAttachments(attach);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
         
                                                {/* COIDA Certificate - Only show if any selected service requires COIDA */}
                                                {requiresCoida && (
                                                    <div className="bg-white border border-gray-200 rounded-xl p-6">
                                                        <div className="flex items-center space-x-2 mb-4">
                                                            <h4 className="font-semibold text-gray-900">COIDA Certificate <span className="text-red-500">*</span></h4> 
                                                            <span className="text-xs text-blue-600 bg-blue-50 px-2 py-1 rounded">Required for selected services</span>
                                                        </div>
                                                
                                                <div className="space-y-4">
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-900 mb-3 bg-green-100 text-green-800 px-3 py-2 rounded-lg">
                                                            COIDA Certificate <span className="text-red-500">*</span>
                                                        </label>
                                                        <input 
                                                            type="file" 
                                                            required
                                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                                                            onChange={(event) => {   
                                                                let attach = {...attachments};
                                                                attach["COIDA Registration Certificate"] = event.target.files[0];
                                                                setAttachments(attach);
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 border-t border-gray-200">
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                COIDA Certificate Number <span className="text-red-500">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="COIDA_Certificate_Number"
                                                                required
                                                                value={formDataObject.COIDA_Certificate_Number || ''}
                                                                onChange={(e) => setFormDataObject(prev => ({ ...prev, COIDA_Certificate_Number: e.target.value }))}
                                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                                                                placeholder="Enter COIDA certificate number"
                                                            />
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                COIDA Certificate Expiry Date <span className="text-red-500">*</span>
                                                            </label>
                                                            <input
                                                                type="date"
                                                                name="COIDA_Certificate_Expiry_Date"
                                                                required
                                                                value={formDataObject.COIDA_Certificate_Expiry_Date || ''}
                                                                onChange={(e) => setFormDataObject(prev => ({ ...prev, COIDA_Certificate_Expiry_Date: e.target.value }))}
                                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                                </div>
                                            );
                                        })()}
                                    </div>
                                )}

                                {/* Step 5: Review & Declarations */}
                                {step === 5 && (
                                    <div className="space-y-6">
                                        <div className="text-center pb-4">
                                            <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-3">
                                                <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </div>
                                            <h2 className="text-xl font-bold text-gray-900 mb-1">Declaration of Conflict of Interest</h2>
                                            <p className="text-sm text-gray-600">Please answer all questions honestly and completely</p>
                                        </div>

                                        {/* Declaration Questions - Compact Grid */}
                                        <div className="space-y-4">
                                            
                                            {/* Questions 1-3: Employment Related */}
                                            <div className="bg-white border border-gray-200 rounded-lg p-4">
                                                <h3 className="font-medium text-gray-900 mb-4">Employment & Relationships</h3>
                                                <div className="space-y-4">
                                                    
                                                    {/* Question 1: Current Employee */}
                                                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 items-center">
                                                        <label className="text-sm font-medium text-gray-700">
                                                            Currently employed by Silulumanzi?
                                                        </label>
                                                        <select 
                                                            name="Declare_Silulumanzi_Employee" 
                                                            className="px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                            onChange={(e) => { setSilulumanzi_Employee(e.target.value); }}
                                                        >
                                                            <option value="No">No</option>
                                                            <option value="Yes">Yes</option>
                                                        </select>
                                                        <input type="hidden" name="Declare_Silulumanzi_Employee_Text" value="Are you currently working as an employee in Silulumanzi and/or related company?" />
                                                        {Silulumanzi_Employee === "Yes" && (
                                                            <div className="lg:col-span-3 mt-2">
                                                                <textarea 
                                                                    className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent" 
                                                                    name="Declare_Silulumanzi_Employee_Details"
                                                                    rows="2"
                                                                    placeholder="Please provide employment details..."
                                                                    required
                                                                />
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Question 2: Recent Employee */}
                                                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 items-center">
                                                        <label className="text-sm font-medium text-gray-700">
                                                            Worked here in past 12 months?
                                                        </label>
                                                        <select 
                                                            name="Declare_Silulumanzi_Recent_Employee" 
                                                            className="px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                            onChange={(e) => { setSilulumanzi_Recent_Employee(e.target.value); }}
                                                        >
                                                            <option value="No">No</option>
                                                            <option value="Yes">Yes</option>
                                                        </select>
                                                        <input type="hidden" name="Declare_Silulumanzi_Recent_Employee_Text" value="Have you worked in Silulumanzi and/or related company for the past 12 months?" />
                                                        {Silulumanzi_Recent_Employee === "Yes" && (
                                                            <div className="lg:col-span-3 mt-2">
                                                                <textarea 
                                                                    className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent" 
                                                                    name="Declare_Silulumanzi_Recent_Employee_Details"
                                                                    rows="2"
                                                                    placeholder="Please provide previous employment details..."
                                                                    required
                                                                />
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Question 3: Employee Relative */}
                                                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 items-center">
                                                        <label className="text-sm font-medium text-gray-700">
                                                            Relatives working here?
                                                        </label>
                                                        <select 
                                                            name="Declare_Silulumanzi_Employee_Relative" 
                                                            className="px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                            onChange={(e) => { setSilulumanzi_Employee_Relative(e.target.value); }}
                                                        >
                                                            <option value="No">No</option>
                                                            <option value="Yes">Yes</option>
                                                        </select>
                                                        <input type="hidden" name="Declare_Silulumanzi_Employee_Relative_Text" value="Do you have any relative working for Silulumanzi and/or related company?" />
                                                        {Silulumanzi_Employee_Relative === "Yes" && (
                                                            <div className="lg:col-span-3 mt-2">
                                                                <textarea 
                                                                    className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent" 
                                                                    name="Declare_Silulumanzi_Employee_Relative_Details"
                                                                    rows="2"
                                                                    placeholder="Please provide relationship details..."
                                                                    required
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Questions 4-6: Other Disclosures */}
                                            <div className="bg-white border border-gray-200 rounded-lg p-4">
                                                <h3 className="font-medium text-gray-900 mb-4">Conflict of Interest & Other Disclosures</h3>
                                                <div className="space-y-4">
                                                    
                                                    {/* Question 4: Official Relationship */}
                                                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 items-center">
                                                        <label className="text-sm font-medium text-gray-700">
                                                            Relationships with officials?
                                                        </label>
                                                        <select 
                                                            name="Declare_Silulumanzi_Official_Relationship" 
                                                            className="px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                            onChange={(e) => { setSilulumanzi_Official_Relationship(e.target.value); }}
                                                        >
                                                            <option value="No">No</option>
                                                            <option value="Yes">Yes</option>
                                                        </select>
                                                        <input type="hidden" name="Declare_Silulumanzi_Official_Relationship_Text" value="Do you have any relationship with any Silulumanzi official that may give rise to a conflict of interest?" />
                                                        {Silulumanzi_Official_Relationship === "Yes" && (
                                                            <div className="lg:col-span-3 mt-2">
                                                                <textarea 
                                                                    className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent" 
                                                                    name="Declare_Silulumanzi_Official_Relationship_Details"
                                                                    rows="2"
                                                                    placeholder="Please describe the relationship..."
                                                                    required
                                                                />
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Question 5: Voluntary Disclosure */}
                                                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 items-center">
                                                        <label className="text-sm font-medium text-gray-700">
                                                            Other matters to disclose?
                                                        </label>
                                                        <select 
                                                            name="Declare_Voluntary_Disclosure" 
                                                            className="px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                            onChange={(e) => { setVoluntary_Disclosure(e.target.value); }}
                                                        >
                                                            <option value="No">No</option>
                                                            <option value="Yes">Yes</option>
                                                        </select>
                                                        <input type="hidden" name="Declare_Voluntary_Disclosure_Text" value="Is there any other matter that you should disclose in order to avoid any conflict of interest?" />
                                                        {Voluntary_Disclosure === "Yes" && (
                                                            <div className="lg:col-span-3 mt-2">
                                                                <textarea 
                                                                    className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent" 
                                                                    name="Declare_Voluntary_Disclosure_Details"
                                                                    rows="2"
                                                                    placeholder="Please provide additional information..."
                                                                    required
                                                                />
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Question 6: Hazardous Substances */}
                                                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 items-center">
                                                        <label className="text-sm font-medium text-gray-700">
                                                            Supplying hazardous substances?
                                                        </label>
                                                        <select 
                                                            name="Declare_Hazardous_Substances" 
                                                            className="px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                            onChange={(e) => { setHazardous_Substances(e.target.value); }}
                                                        >
                                                            <option value="No">No</option>
                                                            <option value="Yes">Yes</option>
                                                        </select>
                                                        <input type="hidden" name="Declare_Hazardous_Substances_Text" value="Will you be supplying hazardous substances as defined in the Occupational Health and Safety Act?" />
                                                        {Hazardous_Substances === "Yes" && (
                                                            <div className="lg:col-span-3 mt-2">
                                                                <textarea 
                                                                    className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent" 
                                                                    name="Declare_Hazardous_Substances_Details"
                                                                    rows="2"
                                                                    placeholder="Please list hazardous substances and safety measures..."
                                                                    required
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Legal Declaration */}
                                            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                                                <div className="flex items-start space-x-3">
                                                    <svg className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16c-.77.833.192 2.5 1.732 2.5z" />
                                                    </svg>
                                                    <div>
                                                        <h3 className="font-semibold text-red-900 mb-2">Legal Declaration</h3>
                                                        <p className="text-sm text-red-800 mb-3">
                                                            I declare that the information furnished is true and correct. Any false information may result in rejection or contract cancellation.
                                                        </p>
                                                        <div className="flex items-center space-x-2">
                                                            <input 
                                                                type="checkbox" 
                                                                id="legal_declaration"
                                                                name="Legal_Declaration"
                                                                required
                                                                className="rounded border-gray-300 text-red-600 focus:ring-red-500"
                                                            />
                                                            <label htmlFor="legal_declaration" className="text-sm font-medium text-red-800">
                                                                I agree to this declaration <span className="text-red-600">*</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Step 6: OTP Verification & Account Setup */}
                                {step === 6 && (
                                    <div className="space-y-6">
                                        {!otpVerified ? (
                                            // OTP Verification Phase
                                            <div className="text-center pb-4">
                                                <div className="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-3">
                                                    <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 3.26a2 2 0 001.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                                    </svg>
                                                </div>
                                                <h2 className="text-xl font-bold text-gray-900 mb-1">Verify Your Email</h2>
                                                <p className="text-sm text-gray-600">We've sent a verification code to your email address</p>
                                            </div>
                                        ) : (
                                            // Password Setup Phase
                                            <div className="text-center pb-4">
                                                <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-3">
                                                    <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                                    </svg>
                                                </div>
                                                <h2 className="text-xl font-bold text-gray-900 mb-1">Setup Your Password</h2>
                                                <p className="text-sm text-gray-600">Create a secure password for your supplier account</p>
                                            </div>
                                        )}

                                        {!otpVerified ? (
                                            // OTP Input Form
                                            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
                                                <div className="space-y-4">
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                                            Verification Code
                                                        </label>
                                                        <input
                                                            type="text"
                                                            value={otpCode}
                                                            onChange={(e) => {
                                                                setOtpCode(e.target.value);
                                                                // Clear any error/success messages when user starts typing
                                                                if (submitStatus && (submitStatus.type === 'error' || submitStatus.type === 'success')) {
                                                                    setSubmitStatus(null);
                                                                }
                                                            }}
                                                            placeholder="Enter 5-digit code"
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                            maxLength="5"
                                                        />
                                                    </div>
                                                    
                                                    {/* Status Messages */}
                                                    {submitStatus && (
                                                        <div className={`p-3 rounded-lg mb-3 ${
                                                            submitStatus.type === 'error' ? 'bg-red-50 border border-red-200 text-red-800' :
                                                            submitStatus.type === 'success' ? 'bg-green-50 border border-green-200 text-green-800' :
                                                            submitStatus.type === 'info' ? 'bg-blue-50 border border-blue-200 text-blue-800' :
                                                            'bg-gray-50 border border-gray-200 text-gray-800'
                                                        }`}>
                                                            <div className="flex items-center">
                                                                {submitStatus.type === 'error' && (
                                                                    <svg className="w-5 h-5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                                                    </svg>
                                                                )}
                                                                {submitStatus.type === 'success' && (
                                                                    <svg className="w-5 h-5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                                    </svg>
                                                                )}
                                                                {submitStatus.type === 'info' && (
                                                                    <svg className="w-5 h-5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                                                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                                                    </svg>
                                                                )}
                                                                <span className="text-sm font-medium">{submitStatus.message}</span>
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="flex space-x-3 mt-2">
                                                        <button
                                                            type="button"
                                                            onClick={handleVerifyOtp}
                                                            disabled={otpCode.length !== 5}
                                                            className="flex-1 px-6 py-3 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 disabled:from-gray-300 disabled:to-gray-400 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl disabled:shadow-none transition-all duration-200 transform hover:scale-[1.02] disabled:transform-none disabled:cursor-not-allowed border-2 border-green-600 hover:border-green-700 disabled:border-gray-300"
                                                        >
                                                            <svg className="w-5 h-5 inline mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                            </svg>
                                                            Verify Code
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={handleResendOtp}
                                                            disabled={isResendingOtp || isSendingOtp}
                                                            className="px-6 py-3 bg-gradient-to-r from-gray-500 to-gray-600 hover:from-gray-600 hover:to-gray-700 disabled:from-gray-300 disabled:to-gray-400 text-white font-medium rounded-lg shadow-md hover:shadow-lg disabled:shadow-none transition-all duration-200 transform hover:scale-[1.02] disabled:transform-none disabled:cursor-not-allowed border-2 border-gray-500 hover:border-gray-600 disabled:border-gray-300"
                                                        >
                                                            {isResendingOtp ? (
                                                                <>
                                                                    <svg className="w-4 h-4 inline mr-2 animate-spin" fill="none" viewBox="0 0 24 24">
                                                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                                    </svg>
                                                                    Sending...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <svg className="w-4 h-4 inline mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                                        <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
                                                                    </svg>
                                                                    Resend
                                                                </>
                                                            )}
                                                        </button>
                                                    </div>

                                                    {/* Debug: Show OTP from debug modal */}
                                                    {settings?.debug_mode === '1' && (
                                                        <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                                                            <p className="text-sm text-yellow-800">
                                                                <strong>Debug Mode:</strong> OTP Code from Debug Modal
                                                            </p>
                                                            <button
                                                                type="button"
                                                                onClick={() => setShowDebugModal(true)}
                                                                className="mt-2 px-3 py-1 bg-yellow-100 text-yellow-800 rounded text-xs hover:bg-yellow-200"
                                                            >
                                                                Get OTP from Debug Modal
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ) : (
                                            // Password Setup Form
                                            <div className="bg-green-50 border border-green-200 rounded-lg p-6">
                                                <div className="space-y-4">
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                                            Password
                                                        </label>
                                                        <input
                                                            type="password"
                                                            value={password}
                                                            onChange={(e) => setPassword(e.target.value)}
                                                            placeholder="Enter your password"
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                                                        />
                                                    </div>
                                                    
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                                            Confirm Password
                                                        </label>
                                                        <input
                                                            type="password"
                                                            value={confirmPassword}
                                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                                            placeholder="Confirm your password"
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                                                        />
                                                    </div>

                                                    {passwordError && (
                                                        <div className="text-red-600 text-sm">{passwordError}</div>
                                                    )}

                                                    <button
                                                        type="button"
                                                        onClick={handleCreateAccount}
                                                        disabled={!password || !confirmPassword || password !== confirmPassword}
                                                        className="w-full px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
                                                    >
                                                        Create Account & Login
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* Footer Navigation - Inside Form */}
                                <div className="mt-8 pt-6 border-t border-gray-200">
                                    <div className="flex justify-between items-center">
                                        <div className="flex space-x-4">
                                            {step > 1 && step < 6 && (
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setStep(step - 1);
                                                        setProgress(Math.max(0, progress - 20));
                                                    }}
                                                    className="px-6 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors flex items-center space-x-2"
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                                                    </svg>
                                                    <span>Previous</span>
                                                </button>
                                            )}
                                            {step < 6 && (
                                                <Link
                                                    to="/supplier/login"
                                                    className="px-6 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                                                >
                                                    Cancel
                                                </Link>
                                            )}
                                            
                                            {/* Debug Button - Controlled by backend settings */}
                                            {settings?.debug_mode === '1' && (
                                                <button
                                                    type="button"
                                                    onClick={() => setShowDebugModal(true)}
                                                    className="px-3 py-2 text-red-700 bg-red-50 border border-red-300 rounded-lg hover:bg-red-100 transition-colors flex items-center space-x-2"
                                                    title="Debug Information"
                                                >
                                                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                    </svg>
                                                    <span>Debug</span>
                                                </button>
                                            )}
                                        </div>
                                        
                                        <div className="flex space-x-4">
                                            {step === 1 && (
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setStep(2);
                                                        setProgress(20);
                                                    }}
                                                    style={{background: 'var(--gradient-primary)'}}
                                                    className="px-8 py-3 text-white rounded-lg hover:opacity-90 transition-all duration-200 font-semibold shadow-lg flex items-center space-x-2"
                                                >
                                                    <span>Continue</span>
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                                    </svg>
                                                </button>
                                            )}
                                            {step > 1 && step < 5 && (
                                                <button
                                                    type="submit"
                                                    style={{background: 'var(--gradient-primary)'}}
                                                    className="px-8 py-3 text-white rounded-lg hover:opacity-90 transition-all duration-200 font-semibold shadow-lg flex items-center space-x-2"
                                                >
                                                    <span>Next Step</span>
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                                    </svg>
                                                </button>
                                            )}
                                            {step === 5 && (
                                                <button
                                                    type="submit"
                                                    style={{background: 'var(--gradient-card-success)'}}
                                                    className="px-8 py-3 text-white rounded-lg hover:opacity-90 transition-all duration-200 font-semibold shadow-lg"
                                                >
                                                    Submit Application
                                                </button>
                                            )}
                                            {/* Step 6 has its own internal navigation for OTP and password setup */}
                                        </div>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Duplicate Detection Modal */}
            {showDuplicateModal && (
                <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                    <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-4 text-center sm:block sm:p-0">
                        {/* Background overlay */}
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
                        
                        {/* Modal panel - more compact */}
                        <div className="inline-block align-middle bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-4 sm:align-middle sm:max-w-3xl sm:w-full">
                            {/* Header - reduced padding */}
                            <div className="px-4 py-3 bg-gradient-warning text-white">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center">
                                        <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                        </svg>
                                        <h3 className="text-lg font-bold" id="modal-title">
                                            Duplicate Company Detected
                                        </h3>
                                    </div>
                                    <button
                                        onClick={() => setShowDuplicateModal(false)}
                                        className="text-white hover:text-gray-200 transition-colors"
                                    >
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            
                            {/* Body - compact layout */}
                            <div className="px-4 py-3" style={{ backgroundColor: 'var(--bg-primary)' }}>
                                {/* Alert section - compact */}
                                <div className="mb-4 p-3 rounded-lg text-sm" style={{ backgroundColor: 'var(--color-warning-soft)', borderLeft: '3px solid var(--color-warning)' }}>
                                    <div className="flex items-center">
                                        <svg className="w-4 h-4 mr-2 flex-shrink-0" style={{ color: 'var(--color-warning)' }} fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                        </svg>
                                        <div>
                                            <span className="font-semibold" style={{ color: 'var(--text-primary)' }}>Company Already Exists - </span>
                                            <span style={{ color: 'var(--text-secondary)' }}>
                                                Found {duplicateMatches.length} existing {duplicateMatches.length === 1 ? 'company' : 'companies'} with similar information.
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                
                                {/* Matches - compact grid */}
                                <div className="space-y-3 mb-4">
                                    {duplicateMatches.map((match, index) => (
                                        <div key={index} className="bg-white rounded-lg shadow-sm border text-sm" style={{ borderColor: 'var(--border-light)' }}>
                                            {/* Card header - compact */}
                                            <div className="px-3 py-2 bg-gradient-info text-white rounded-t-lg">
                                                <div className="flex items-center">
                                                    <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-6a1 1 0 00-1-1H9a1 1 0 00-1 1v6a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd" />
                                                    </svg>
                                                    <span className="font-semibold text-sm">
                                                        Match {index + 1}: {match.company_name}
                                                    </span>
                                                </div>
                                            </div>
                                            
                                            {/* Card body - proper spacing for readability */}
                                            <div className="p-4">
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                                                    <div className="space-y-3">
                                                        <div>
                                                            <span className="font-medium" style={{ color: 'var(--text-primary)' }}>Company Name:</span>
                                                            <div className="text-sm mt-1" style={{ color: 'var(--text-secondary)' }}>{match.company_name}</div>
                                                        </div>
                                                        {match.registered_name !== match.company_name && (
                                                            <div>
                                                                <span className="font-medium" style={{ color: 'var(--text-primary)' }}>Registered Name:</span>
                                                                <div className="text-sm mt-1" style={{ color: 'var(--text-secondary)' }}>{match.registered_name}</div>
                                                            </div>
                                                        )}
                                                        <div>
                                                            <span className="font-medium" style={{ color: 'var(--text-primary)' }}>Email:</span>
                                                            <div className="text-sm mt-1" style={{ color: 'var(--text-secondary)' }}>{match.email}</div>
                                                        </div>
                                                    </div>
                                                    <div className="space-y-3">
                                                        <div>
                                                            <span className="font-medium" style={{ color: 'var(--text-primary)' }}>Status:</span>
                                                            <div className="mt-1">
                                                                <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                                                    match.status === 1 
                                                                        ? 'text-white' 
                                                                        : 'text-gray-600'
                                                                }`} style={{ 
                                                                    backgroundColor: match.status === 1 ? 'var(--color-success)' : 'var(--status-pending)'
                                                                }}>
                                                                    {match.status === 1 ? 'Active' : 'Inactive'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <span className="font-medium block mb-2" style={{ color: 'var(--text-primary)' }}>Matching Criteria:</span>
                                                            <div className="flex flex-wrap gap-1">
                                                                {match.match_reasons.map((reason, i) => (
                                                                    <span 
                                                                        key={i} 
                                                                        className="px-2 py-1 rounded-full text-xs font-medium text-white"
                                                                        style={{ backgroundColor: 'var(--color-accent)' }}
                                                                    >
                                                                        {reason}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                {/* Company Action Button */}
                                                <div className="mt-6 px-4 pb-4">
                                                    <button
                                                        onClick={() => handleVerifyCompany(match)}
                                                        disabled={isSendingOtp}
                                                        className="w-full px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 disabled:from-gray-300 disabled:to-gray-400 text-white text-base font-semibold rounded-lg shadow-lg hover:shadow-xl disabled:shadow-none transition-all duration-200 transform hover:scale-[1.02] disabled:transform-none disabled:cursor-not-allowed flex items-center justify-center border-2 border-blue-600 hover:border-blue-700 disabled:border-gray-300"
                                                    >
                                                        {isSendingOtp ? (
                                                            <>
                                                                <svg className="w-5 h-5 mr-2 animate-spin" fill="none" viewBox="0 0 24 24">
                                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                                </svg>
                                                                Sending verification code...
                                                            </>
                                                        ) : (
                                                            <>
                                                                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                                </svg>
                                                                This is my company
                                                            </>
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                
                                {/* Information section - proper formatting */}
                                <div className="p-4 rounded-lg text-sm" style={{ backgroundColor: 'var(--antiflash-white)', borderLeft: '3px solid var(--color-info)' }}>
                                    <div className="flex items-start">
                                        <svg className="w-5 h-5 mr-3 mt-0.5 flex-shrink-0" style={{ color: 'var(--color-info)' }} fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                                        </svg>
                                        <div>
                                            <div className="font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>What to do:</div>
                                            <div className="space-y-1" style={{ color: 'var(--text-secondary)' }}>
                                                <div><strong>Your company?</strong> Contact support to update info or regain access.</div>
                                                <div><strong>Different company?</strong> Check your details and try again.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Footer - compact */}
                            <div className="px-4 py-4 bg-gray-50 border-t flex flex-col sm:flex-row justify-between items-center gap-3">
                                <button 
                                    type="button" 
                                    className="w-full sm:w-auto px-4 py-2 bg-gradient-to-r from-orange-600 to-orange-700 hover:from-orange-700 hover:to-orange-800 text-white text-sm font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-[1.02] border-2 border-orange-600 hover:border-orange-700"
                                    onClick={() => {
                                        window.open('mailto:support@silulumanzi.co.za?subject=Duplicate Company Registration', '_blank');
                                    }}
                                >
                                    <svg className="w-4 h-4 inline mr-2" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                    </svg>
                                    Contact Support
                                </button>
                                <div className="flex gap-3 w-full sm:w-auto">
                                    <button 
                                        type="button" 
                                        className="flex-1 sm:flex-none px-4 py-2 border-2 border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-100 hover:border-gray-400 transition-all duration-200 transform hover:scale-[1.02]"
                                        onClick={() => setShowDuplicateModal(false)}
                                    >
                                        Review Information
                                    </button>
                                    <button 
                                        type="button" 
                                        className="flex-1 sm:flex-none px-4 py-2 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white text-sm font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-[1.02] border-2 border-gray-600 hover:border-gray-700"
                                        onClick={() => {
                                            setShowDuplicateModal(false);
                                        }}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            
            {/* OTP Verification Modal for Company Verification */}
            {showOtpVerification && (
                <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                    <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-4 text-center sm:block sm:p-0">
                        {/* Background overlay */}
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
                        
                        {/* Modal panel */}
                        <div className="inline-block align-middle bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-4 sm:align-middle sm:max-w-md sm:w-full">
                            {/* Header */}
                            <div className="px-4 py-3 bg-gradient-primary text-white">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center">
                                        <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                        </svg>
                                        <h3 className="text-lg font-bold" id="modal-title">
                                            Verify Company Ownership
                                        </h3>
                                    </div>
                                    <button
                                        onClick={() => {
                                            setShowOtpVerification(false);
                                            setVerificationOtp('');
                                            setNewRegisterFeedback('');
                                        }}
                                        className="text-white hover:text-gray-200 transition-colors"
                                    >
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            
                            {/* Body */}
                            <div className="px-4 py-4" style={{ backgroundColor: 'var(--bg-primary)' }}>
                                <div className="mb-4 p-3 rounded-lg text-sm" style={{ backgroundColor: 'var(--color-info-soft)', borderLeft: '3px solid var(--color-info)' }}>
                                    <div className="flex items-center">
                                        <svg className="w-4 h-4 mr-2 flex-shrink-0" style={{ color: 'var(--color-info)' }} fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                        </svg>
                                        <div>
                                            <span className="font-semibold" style={{ color: 'var(--text-primary)' }}>Verification Required - </span>
                                            <span style={{ color: 'var(--text-secondary)' }}>
                                                We've sent a verification code to <strong>{otpSentToEmail}</strong>. Please enter it below to continue with your existing application.
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                
                                {selectedCompanyForVerification && (
                                    <div className="mb-4 p-3 bg-white rounded-lg border" style={{ borderColor: 'var(--border-light)' }}>
                                        <div className="flex items-center mb-2">
                                            <svg className="w-4 h-4 mr-2" style={{ color: 'var(--color-primary)' }} fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-6a1 1 0 00-1-1H9a1 1 0 00-1 1v6a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd" />
                                            </svg>
                                            <span className="font-semibold text-sm" style={{ color: 'var(--text-primary)' }}>
                                                {selectedCompanyForVerification.company_name}
                                            </span>
                                        </div>
                                        <div className="text-xs" style={{ color: 'var(--text-secondary)' }}>
                                            <div><strong>Email:</strong> {selectedCompanyForVerification.email}</div>
                                            <div><strong>Status:</strong> {selectedCompanyForVerification.status === 1 ? 'Active' : 'Inactive'}</div>
                                        </div>
                                    </div>
                                )}
                                
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium mb-2" style={{ color: 'var(--text-primary)' }}>
                                            Verification Code <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            value={verificationOtp}
                                            onChange={(e) => setVerificationOtp(e.target.value)}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-colors text-center font-mono text-lg"
                                            style={{ 
                                                focusRingColor: 'var(--color-primary)',
                                                backgroundColor: verificationOtp.length >= 4 ? 'var(--color-success-soft)' : 'white'
                                            }}
                                            placeholder="Enter verification code"
                                            maxLength="6"
                                            autoComplete="one-time-code"
                                        />
                                    </div>
                                    
                                    {newRegisterFeedback && (
                                        <div className={`p-3 rounded-lg text-sm ${
                                            newRegisterFeedback.includes('Error') || newRegisterFeedback.includes('Invalid') 
                                                ? 'bg-red-50 text-red-700 border-l-4 border-red-400' 
                                                : 'bg-blue-50 text-blue-700 border-l-4 border-blue-400'
                                        }`}>
                                            {newRegisterFeedback}
                                        </div>
                                    )}
                                </div>
                            </div>
                            
                            {/* Footer */}
                            <div className="px-4 py-4 bg-gray-50 border-t flex flex-col sm:flex-row justify-between items-center gap-3">
                                <button 
                                    type="button" 
                                    className="w-full sm:w-auto px-4 py-2 border-2 border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-100 hover:border-gray-400 transition-all duration-200 transform hover:scale-[1.02]"
                                    onClick={() => {
                                        setShowOtpVerification(false);
                                        setVerificationOtp('');
                                        setNewRegisterFeedback('');
                                    }}
                                >
                                    Cancel
                                </button>
                                <button 
                                    type="button" 
                                    className="w-full sm:w-auto px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 disabled:from-gray-300 disabled:to-gray-400 text-white text-base font-semibold rounded-lg shadow-lg hover:shadow-xl disabled:shadow-none transition-all duration-200 transform hover:scale-[1.02] disabled:transform-none disabled:cursor-not-allowed border-2 border-blue-600 hover:border-blue-700 disabled:border-gray-300"
                                    onClick={verifyOtpAndContinue}
                                    disabled={!verificationOtp || verificationOtp.length < 4}
                                >
                                    <svg className="w-5 h-5 inline mr-2" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                    </svg>
                                    Verify & Continue
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            
            {/* Incomplete Applications Modal */}
            {showIncompleteModal && (
                <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                    <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-4 text-center sm:block sm:p-0">
                        {/* Background overlay */}
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
                        
                        {/* Modal panel */}
                        <div className="inline-block align-middle bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-4 sm:align-middle sm:max-w-2xl sm:w-full">
                            {/* Header */}
                            <div className="px-4 py-3 bg-gradient-info text-white">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center">
                                        <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                        </svg>
                                        <h3 className="text-lg font-bold" id="modal-title">
                                            Continue Incomplete Application
                                        </h3>
                                    </div>
                                    <button
                                        onClick={() => setShowIncompleteModal(false)}
                                        className="text-white hover:text-gray-200 transition-colors"
                                    >
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            
                            {/* Body */}
                            <div className="px-4 py-4" style={{ backgroundColor: 'var(--bg-primary)' }}>
                                <div className="mb-4 p-3 rounded-lg text-sm" style={{ backgroundColor: 'var(--color-info-soft)', borderLeft: '3px solid var(--color-info)' }}>
                                    <div className="flex items-center">
                                        <svg className="w-4 h-4 mr-2 flex-shrink-0" style={{ color: 'var(--color-info)' }} fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                        </svg>
                                        <div>
                                            <span className="font-semibold" style={{ color: 'var(--text-primary)' }}>Incomplete Applications Found - </span>
                                            <span style={{ color: 'var(--text-secondary)' }}>
                                                You have {incompleteApplications.length} incomplete application{incompleteApplications.length !== 1 ? 's' : ''}. Would you like to continue where you left off?
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="space-y-3">
                                    {incompleteApplications.map((app, index) => (
                                        <div key={app.reference} className="bg-white rounded-lg shadow-sm border p-4" style={{ borderColor: 'var(--border-light)' }}>
                                            <div className="flex items-center justify-between">
                                                <div className="flex-1">
                                                    <div className="flex items-center mb-2">
                                                        <svg className="w-4 h-4 mr-2" style={{ color: 'var(--color-primary)' }} fill="currentColor" viewBox="0 0 20 20">
                                                            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-6a1 1 0 00-1-1H9a1 1 0 00-1 1v6a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd" />
                                                        </svg>
                                                        <span className="font-semibold text-sm" style={{ color: 'var(--text-primary)' }}>
                                                            Reference: {app.reference}
                                                        </span>
                                                    </div>
                                                    <div className="grid grid-cols-2 gap-4 text-xs" style={{ color: 'var(--text-secondary)' }}>
                                                        <div>
                                                            <span className="font-medium">Company:</span> {app.company_name || 'Not specified'}
                                                        </div>
                                                        <div>
                                                            <span className="font-medium">Progress:</span> {app.progress || 0}%
                                                        </div>
                                                        <div>
                                                            <span className="font-medium">Last Updated:</span> {app.last_updated || 'Unknown'}
                                                        </div>
                                                        <div>
                                                            <span className="font-medium">Step:</span> {
                                                                app.progress >= 80 ? 'Review' :
                                                                app.progress >= 60 ? 'Experience' :
                                                                app.progress >= 40 ? 'Services' :
                                                                app.progress >= 20 ? 'Business Info' : 'Introduction'
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="ml-4">
                                                    <button
                                                        onClick={() => continueIncompleteApplication(app)}
                                                        className="px-4 py-2 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white text-sm font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-[1.02] border-2 border-green-600 hover:border-green-700"
                                                    >
                                                        <svg className="w-4 h-4 inline mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                                                        </svg>
                                                        Continue
                                                    </button>
                                                </div>
                                            </div>
                                            
                                            {/* Progress bar */}
                                            <div className="mt-3">
                                                <div className="flex items-center justify-between text-xs mb-1">
                                                    <span style={{ color: 'var(--text-secondary)' }}>Progress</span>
                                                    <span style={{ color: 'var(--text-primary)' }}>{app.progress || 0}%</span>
                                                </div>
                                                <div className="w-full bg-gray-200 rounded-full h-2">
                                                    <div 
                                                        className="h-2 rounded-full transition-all duration-300"
                                                        style={{ 
                                                            backgroundColor: 'var(--color-primary)',
                                                            width: `${app.progress || 0}%`
                                                        }}
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            
                            {/* Footer */}
                            <div className="px-4 py-4 bg-gray-50 border-t flex justify-between items-center">
                                <span className="text-sm text-gray-600">
                                    Select an application to continue or start a new one
                                </span>
                                <div className="flex gap-3">
                                    <button 
                                        type="button" 
                                        className="px-4 py-2 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white text-sm font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-[1.02] border-2 border-blue-600 hover:border-blue-700"
                                        onClick={() => {
                                            setShowIncompleteModal(false);
                                            setIsContinuingApplication(false); // Reset flag for new application
                                        }}
                                    >
                                        <svg className="w-4 h-4 inline mr-2" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
                                        </svg>
                                        Start New Application
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            
            {/* Debug Modal - Controlled by backend settings */}
            {settings?.debug_mode === '1' && (
                <DebugModal 
                    show={showDebugModal}
                    onHide={() => setShowDebugModal(false)}
                    step={step}
                    progress={progress}
                    formDataObject={formDataObject}
                    setFormDataObject={setFormDataObject}
                    businessType={businessType}
                    setBusinessType={setBusinessType}
                    attachments={attachments}
                    setAttachments={setAttachments}
                    services={services}
                    selected={selected}
                    setSelected={setSelected}
                    sameAsPhysical={sameAsPhysical}
                    setSameAsPhysical={setSameAsPhysical}
                    populateCurrentSection={populateCurrentSection}
                    autoSelectServices={autoSelectServices}
                    attachDemoFiles={attachDemoFiles}
                    clearAllData={clearAllData}
                    otpCode={otpCode}
                    setOtpCode={setOtpCode}
                    actualOtp={actualOtp}
                    fetchActualOtp={fetchActualOtp}
                    allData={{
                        step,
                        progress,
                        formDataObject,
                        businessType,
                        attachments,
                        services,
                        selected,
                        newRegisterFeedback,
                        registerFeedback,
                        Silulumanzi_Employee,
                        Silulumanzi_Recent_Employee,
                        Silulumanzi_Employee_Relative,
                        Silulumanzi_Official_Relationship,
                        Voluntary_Disclosure,
                        Hazardous_Substances,
                        sameAsPhysical,
                        otpCode,
                        otpSent,
                        otpVerified,
                        actualOtp
                    }}
                    settings={settings}
                />
            )}
        </div>
    );
};

// Debug Modal Component for New Supplier Registration
const DebugModal = ({ 
    show, 
    onHide, 
    step, 
    progress, 
    formDataObject, 
    setFormDataObject,
    businessType, 
    setBusinessType,
    attachments, 
    setAttachments,
    services, 
    selected, 
    setSelected,
    sameAsPhysical,
    setSameAsPhysical,
    allData,
    populateCurrentSection,
    autoSelectServices,
    attachDemoFiles,
    clearAllData,
    otpCode,
    setOtpCode,
    actualOtp,
    fetchActualOtp,
    settings
}) => {
    const [selectedSection, setSelectedSection] = React.useState('overview');
    
    // Security check - only render when backend debug mode is enabled
    if (settings?.debug_mode !== '1') {
        return null;
    }

    const dataStructure = {
        overview: {
            title: 'Overview',
            icon: '📋',
            data: {
                current_step: step,
                progress_percentage: progress,
                form_completion: {
                    registered_company_name: formDataObject?.Registered_Company_Name || 'Not filled',
                    holding_company_name: formDataObject?.Holding_Company_Name || 'Not filled',
                    trading_company_name: formDataObject?.Trading_Company_Name || 'Not filled',
                    business_type: formDataObject?.Business_Type || 'Not selected',
                    physical_address: formDataObject?.Physical_Address || 'Not filled',
                    postal_address: formDataObject?.Postal_Address || 'Not filled',
                    selected_services_count: selected?.length || 0,
                    attachments_count: Object.keys(attachments || {}).length
                },
                validation_status: {
                    step_1_complete: step > 1,
                    step_2_complete: step > 2,
                    step_3_complete: step > 3,
                    step_4_complete: step > 4,
                    step_5_complete: step > 5,
                    form_submitted: step === 6
                }
            }
        },
        auto_populate: {
            title: 'Auto-Populate',
            icon: '🚀',
            data: {
                note: 'Smart form filling for testing purposes',
                available_actions: [
                    'Basic Info - Fills company name, contact person, email, phone',
                    'Full Profile - Complete business information with realistic data',
                    'Select Services - Auto-selects first 3-5 services',
                    'Attach Demo Files - Attaches demo PDF files to file inputs',
                    'Same Address - Copies physical to postal address',
                    'Clear All - Resets all form data'
                ]
            }
        },
        attachments: {
            title: 'File Attachments',
            icon: '📎',
            data: {
                business_type: businessType,
                required_documents: businessType,
                attachments_count: Object.keys(attachments || {}).length,
                demo_files: {
                    available: ['1.pdf', '2.pdf', '3.pdf', '4.pdf', '5.pdf', '6.pdf', '7.pdf', '8.pdf', '9.pdf', '10.pdf'],
                    location: 'documents/ directory',
                    note: 'Demo PDF files for testing file attachment functionality'
                },
                current_attachments: attachments
            }
        },
        otp_testing: {
            title: 'OTP Testing',
            icon: '🔐',
            data: {
                current_step: step,
                otp_required: step === 6,
                current_otp: otpCode,
                actual_otp: actualOtp,
                note: 'Shows the actual OTP sent to the email for verification'
            }
        },
        form_data: {
            title: 'Form Data',
            icon: '📝',
            data: formDataObject || {}
        },
        business_info: {
            title: 'Business Information',
            icon: '🏢',
            data: {
                business_type: businessType,
                business_type_length: businessType?.length || 0,
                form_business_type: formDataObject?.Business_Type,
                attachments: attachments,
                attachments_keys: Object.keys(attachments || {}),
                declarations: {
                    silulumanzi_employee: allData?.Silulumanzi_Employee,
                    recent_employee: allData?.Silulumanzi_Recent_Employee,
                    employee_relative: allData?.Silulumanzi_Employee_Relative,
                    official_relationship: allData?.Silulumanzi_Official_Relationship,
                    voluntary_disclosure: allData?.Voluntary_Disclosure,
                    hazardous_substances: allData?.Hazardous_Substances
                }
            }
        },
        services: {
            title: 'Services Selection',
            icon: '🔧',
            data: {
                available_services: services ? services.map(s => ({label: s.label, value: s.value})) : [],
                available_services_count: services?.length || 0,
                selected_services: selected ? selected.map(s => ({label: s.label, value: s.value})) : [],
                selected_services_count: selected?.length || 0,
                services_sample: services?.slice(0, 5)?.map(s => ({label: s.label, value: s.value})) || []
            }
        },
        feedback: {
            title: 'Feedback & Messages',
            icon: '💬',
            data: {
                new_register_feedback: allData?.newRegisterFeedback,
                register_feedback: allData?.registerFeedback,
                feedback_exists: !!(allData?.newRegisterFeedback || allData?.registerFeedback)
            }
        },
        raw: {
            title: 'Raw Data',
            icon: '🔧',
            data: allData
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="xl" className="debug-modal">
            <Modal.Header closeButton className="bg-red-600 text-white">
                <Modal.Title>
                    <svg className="inline-block mr-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    Debug Information - New Supplier Registration
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">
                <div className="flex" style={{ height: '600px' }}>
                    {/* Navigation Sidebar */}
                    <div className="w-1/4 border-r bg-gray-50">
                        <div className="p-4">
                            <h6 className="text-sm font-bold mb-4 uppercase tracking-wider text-gray-600">
                                Data Sections
                            </h6>
                            <div className="space-y-1">
                                {Object.entries(dataStructure).map(([key, section]) => (
                                    <button
                                        key={key}
                                        className={`w-full text-left px-3 py-2 rounded-lg transition-all duration-200 text-sm font-medium ${
                                            selectedSection === key 
                                                ? 'bg-blue-600 text-white shadow-sm' 
                                                : 'text-gray-700 hover:bg-gray-100 border border-gray-200'
                                        }`}
                                        onClick={() => setSelectedSection(key)}
                                    >
                                        <span className="mr-2">{section.icon}</span>
                                        {section.title}
                                        {key === 'overview' && (
                                            <div className="text-xs mt-1 opacity-75">
                                                Step {step} of 6
                                            </div>
                                        )}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    
                    {/* Content Area */}
                    <div className="flex-1 bg-white">
                        <div className="p-4 h-full overflow-auto">
                            <div className="flex items-center mb-4">
                                <span className="mr-3 text-xl">{dataStructure[selectedSection].icon}</span>
                                <h5 className="text-lg font-semibold text-gray-900">
                                    {dataStructure[selectedSection].title}
                                </h5>
                            </div>
                            
                            {selectedSection === 'overview' ? (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div className="rounded-lg border border-blue-200 shadow-sm">
                                        <div className="px-4 py-3 bg-blue-600 text-white rounded-t-lg" style={{ backgroundColor: '#2563eb' }}>
                                            <h6 className="text-sm font-semibold text-white">Registration Progress</h6>
                                        </div>
                                        <div className="p-4 bg-white">
                                            <div className="space-y-2 text-sm">
                                                <div className="flex justify-between">
                                                    <span className="font-medium">Current Step:</span>
                                                    <span>{step} of 6</span>
                                                </div>
                                                <div className="flex justify-between">
                                                    <span className="font-medium">Progress:</span>
                                                    <span>{progress}%</span>
                                                </div>
                                                <div className="flex justify-between">
                                                    <span className="font-medium">Services Selected:</span>
                                                    <span>{selected?.length || 0}</span>
                                                </div>
                                                <div className="flex justify-between">
                                                    <span className="font-medium">Attachments:</span>
                                                    <span>{Object.keys(attachments || {}).length}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="rounded-lg border border-green-200 shadow-sm">
                                        <div className="px-4 py-3 bg-green-600 text-white rounded-t-lg" style={{ backgroundColor: '#059669' }}>
                                            <h6 className="text-sm font-semibold text-white">Company Information</h6>
                                        </div>
                                        <div className="p-4 bg-white">
                                            <div className="space-y-2 text-sm">
                                                <div className="flex justify-between">
                                                    <span className="font-medium">Registered Name:</span>
                                                    <span className="text-right ml-2">{formDataObject?.Registered_Company_Name || 'Not filled'}</span>
                                                </div>
                                                <div className="flex justify-between">
                                                    <span className="font-medium">Business Type:</span>
                                                    <span className="text-right ml-2">{formDataObject?.Business_Type || 'Not selected'}</span>
                                                </div>
                                                <div className="flex justify-between">
                                                    <span className="font-medium">Contact Email:</span>
                                                    <span className="text-right ml-2">{formDataObject?.Contact_Email || 'Not filled'}</span>
                                                </div>
                                                <div className="flex justify-between">
                                                    <span className="font-medium">Same Address:</span>
                                                    <span className={`px-2 py-1 rounded text-xs ${
                                                        allData?.sameAsPhysical ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                                                    }`}>
                                                        {allData?.sameAsPhysical ? 'Yes' : 'No'}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : selectedSection === 'auto_populate' ? (
                                <div className="space-y-4">
                                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                                        <h6 className="font-semibold mb-3">Fill Business Information Section</h6>
                                        <div className="grid grid-cols-2 gap-3">
                                            <button
                                                onClick={populateCurrentSection}
                                                className="px-4 py-3 text-center bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white border-2 border-blue-600 hover:border-blue-700 rounded-lg font-semibold shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-[1.02]"
                                            >
                                                <div className="text-sm">Fill All Fields in Current Section</div>
                                            </button>
                                            <button
                                                onClick={autoSelectServices}
                                                className="px-4 py-3 text-center bg-gradient-to-r from-gray-100 to-gray-200 hover:from-gray-200 hover:to-gray-300 text-gray-800 border-2 border-gray-300 hover:border-gray-400 rounded-lg font-semibold shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-[1.02]"
                                            >
                                                <div className="text-sm">Select Sample Services</div>
                                            </button>
                                            <button
                                                onClick={attachDemoFiles}
                                                className="px-4 py-3 text-center bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white border-2 border-green-600 hover:border-green-700 rounded-lg font-semibold shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-[1.02]"
                                            >
                                                <div className="text-sm">📎 Attach Demo Files (PDF)</div>
                                            </button>
                                            <button
                                                onClick={clearAllData}
                                                className="px-4 py-3 text-center bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white border-2 border-red-600 hover:border-red-700 rounded-lg font-semibold shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-[1.02]"
                                            >
                                                <div className="text-sm">Clear All Data</div>
                                            </button>
                                        </div>
                                        
                                        <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded text-sm">
                                            <strong>📎 File Attachment Instructions:</strong><br/>
                                            1. First select a Business Type in Step 2<br/>
                                            2. Navigate to Step 4 (Documents) to see file inputs<br/>
                                            3. Use this debug panel to attach demo files<br/>
                                            4. Files will show green borders when attached
                                        </div>
                                    </div>
                                    
                                    <div className="text-sm text-gray-600">
                                        <strong>Current Status:</strong><br/>
                                        Company Name: {formDataObject?.Company_Registered_Name ? '✅ Filled' : '❌ Empty'}<br/>
                                        Email: {formDataObject?.E_Mail ? '✅ Filled' : '❌ Empty'}<br/>
                                        Phone: {formDataObject?.Business_Phone ? '✅ Filled' : '❌ Empty'}<br/>
                                        Telephone: {formDataObject?.Tel ? '✅ Filled' : '❌ Empty'}<br/>
                                        Mobile: {formDataObject?.Mobile_Phone ? '✅ Filled' : '❌ Empty'}<br/>
                                        Website: {formDataObject?.Business_Web_Address ? '✅ Filled' : '❌ Empty'}<br/>
                                        Registration: {formDataObject?.Company_Reg ? '✅ Filled' : '❌ Empty'}<br/>
                                        VAT Number: {formDataObject?.Vat_Registration ? '✅ Filled' : '❌ Empty'}<br/>
                                        Employees: {formDataObject?.Number_of_Employees ? '✅ Filled' : '❌ Empty'}<br/>
                                        Turnover: {formDataObject?.Annual_Turnover ? '✅ Filled' : '❌ Empty'}<br/>
                                        Country: {formDataObject?.Country ? '✅ Filled' : '❌ Empty'}<br/>
                                        Address: {formDataObject?.Address ? '✅ Filled' : '❌ Empty'}<br/>
                                        City: {formDataObject?.City ? '✅ Filled' : '❌ Empty'}<br/>
                                        Settlement Discount: {formDataObject?.Settlement_Discount ? '✅ Filled' : '❌ Empty'}<br/>
                                        Available Services: {services?.length || 0} loaded<br/>
                                        Selected Services: {selected?.length || 0} selected<br/>
                                        <strong>File Attachments:</strong><br/>
                                        Business Type Selected: {formDataObject?.Business_Type ? '✅' : '❌'}<br/>
                                        Required Documents: {businessType?.length || 0} types<br/>
                                        Attachments Added: {Object.keys(attachments || {}).length} files<br/>
                                        <strong>Document Fields:</strong><br/>
                                        BBBEE Type: {formDataObject?.BBBEE_Type ? '✅ Filled' : '❌ Empty'}<br/>
                                        BBBEE Level: {formDataObject?.BBBEE_Level ? '✅ Filled' : '❌ Empty'}<br/>
                                        BBBEE Expiry: {formDataObject?.BBBEE_Expiration_Date ? '✅ Filled' : '❌ Empty'}<br/>
                                        Tax Cert Number: {formDataObject?.Tax_Certification_Number ? '✅ Filled' : '❌ Empty'}<br/>
                                        Tax Cert Expiry: {formDataObject?.Tax_Certificate_Expiry_Date ? '✅ Filled' : '❌ Empty'}<br/>
                                        COIDA Number: {formDataObject?.COIDA_Certificate_Number ? '✅ Filled' : '❌ Empty'}<br/>
                                        COIDA Expiry: {formDataObject?.COIDA_Certificate_Expiry_Date ? '✅ Filled' : '❌ Empty'}
                                    </div>
                                </div>
                            ) : selectedSection === 'otp_testing' ? (
                                <div className="space-y-4">
                                    <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
                                        <h6 className="font-semibold mb-3 text-purple-800">OTP Testing Tools</h6>
                                        <p className="text-sm text-purple-700 mb-4">
                                            Current Step: {step} {step === 6 ? '(OTP Required)' : '(OTP Not Required Yet)'}
                                        </p>
                                        
                                        {step === 6 && (
                                            <div className="space-y-3">
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Actual OTP from Database:
                                                    </label>
                                                    {actualOtp ? (
                                                        <div className="flex items-center space-x-2">
                                                            <div className="px-4 py-2 bg-green-100 text-green-800 rounded font-mono text-lg font-bold border-2 border-green-300">
                                                                {actualOtp}
                                                            </div>
                                                            <button
                                                                onClick={() => {
                                                                    setOtpCode(actualOtp);
                                                                    onHide(); // Close modal after selecting OTP
                                                                }}
                                                                className="px-3 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors"
                                                            >
                                                                Use This OTP
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div className="flex items-center space-x-2">
                                                            <div className="px-4 py-2 bg-gray-100 text-gray-500 rounded font-mono">
                                                                No OTP generated yet
                                                            </div>
                                                            <button
                                                                onClick={async () => {
                                                                    const email = allData?.formDataObject?.E_Mail || allData?.reviewData?.email;
                                                                    if (email) {
                                                                        await fetchActualOtp(email);
                                                                    }
                                                                }}
                                                                className="px-3 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                                                            >
                                                                Fetch OTP
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                                
                                                <div className="pt-3 border-t border-purple-200">
                                                    <p className="text-sm text-purple-600">
                                                        <strong>Current Input:</strong> {otpCode || 'None entered'}
                                                    </p>
                                                    <p className="text-xs text-purple-500 mt-1">
                                                        This shows the actual 5-digit OTP that was sent via email and stored in the database.
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                        
                                        {step !== 6 && (
                                            <div className="text-center py-4">
                                                <p className="text-gray-500 text-sm">
                                                    OTP testing is only available in Step 6 (Account Setup)
                                                </p>
                                                <p className="text-xs text-gray-400 mt-1">
                                                    Complete the supplier registration form to reach Step 6
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <div className="structured-data">
                                    <pre 
                                        className="p-4 rounded-lg text-xs overflow-auto whitespace-pre-wrap break-words bg-gray-100 text-gray-800 border" 
                                        style={{ 
                                            maxHeight: '500px',
                                            lineHeight: '1.4',
                                            fontFamily: 'Monaco, Consolas, "Courier New", monospace'
                                        }}
                                    >
                                        {JSON.stringify(dataStructure[selectedSection].data, null, 2)}
                                    </pre>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="bg-gray-50">
                <button
                    className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 transition-colors"
                    onClick={onHide}
                >
                    Close
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default NewSupplier;
